module.exports = {
	"IcoMoonType": "selection",
	"icons": [
		{
			"icon": {
				"paths": [
					"M48 1024h672c26.464 0 48-21.536 48-48v-240c0-0.32-0.16-0.576-0.192-0.896 1.76-1.12 3.584-2.176 5.312-3.36l255.552 255.552c3.136 3.136 7.232 4.704 11.328 4.704s8.192-1.568 11.328-4.672c6.24-6.24 6.24-16.384 0-22.624l-253.216-253.216c40.448-37.984 65.888-91.776 65.888-151.488 0-73.504-38.432-138.112-96.192-175.104 0.032-0.32 0.192-0.576 0.192-0.896v-80c0-0.544-0.256-0.992-0.288-1.504-0.064-0.736-0.256-1.376-0.416-2.080-0.544-2.272-1.472-4.32-2.88-6.112-0.224-0.288-0.192-0.64-0.416-0.928l-256-288c-0.096-0.096-0.224-0.096-0.32-0.192-1.92-2.080-4.384-3.456-7.136-4.288-0.608-0.192-1.152-0.256-1.792-0.352-0.928-0.16-1.792-0.544-2.752-0.544h-448c-26.464 0-48 21.536-48 48v928c0 26.464 21.536 48 48 48zM832 560c0 97.056-78.976 176-176 176s-176-78.944-176-176 78.976-176 176-176 176 78.944 176 176zM512 58.080l204.384 229.92h-188.384c-7.040 0-16-13.44-16-24v-205.92zM32 48c0-8.832 7.2-16 16-16h432v232c0 25.888 20.96 56 48 56h208v48.032c-24.64-10.304-51.648-16.032-80-16.032-58.816 0-111.872 24.64-149.728 64h-330.272c-8.832 0-16 7.168-16 16s7.168 16 16 16h305.024c-18.080 28.128-29.504 60.832-32.192 96h-272.832c-8.832 0-16 7.168-16 16s7.168 16 16 16h272.8c2.688 35.168 14.144 67.872 32.192 96h-304.992c-8.832 0-16 7.168-16 16s7.168 16 16 16h328c0.672 0 1.248-0.288 1.92-0.384 37.888 39.584 91.104 64.384 150.080 64.384 28.352 0 55.36-5.728 80-16.064v224.064c0 8.832-7.2 16-16 16h-672c-8.96 0-16-7.040-16-16v-928zM176 320h192c8.832 0 16-7.168 16-16s-7.168-16-16-16h-192c-8.832 0-16 7.168-16 16s7.168 16 16 16zM176 832h416c8.832 0 16-7.168 16-16s-7.168-16-16-16h-416c-8.832 0-16 7.168-16 16s7.168 16 16 16z"
				],
				"width": 1056,
				"attrs": [
					{}
				],
				"isMulticolor": false,
				"isMulticolor2": false,
				"tags": [
					"search",
					"lookup",
					"find",
					"magnifier"
				],
				"grid": 32
			},
			"attrs": [
				{}
			],
			"properties": {
				"order": 1,
				"id": 0,
				"prevSize": 32,
				"code": 59691,
				"name": "search1"
			},
			"setIdx": 0,
			"setId": 6,
			"iconIdx": 0
		},
		{
			"icon": {
				"paths": [
					"M1152.064 736.32l1.824-546.848-993.6 0.608-0.032-62.72h1055.744v608.992l-63.936-0.032zM1119.84 832.544l-63.904-0.064 1.824-546.848-993.6 0.64-0.032-62.72h1055.744v608.992zM1025.696 896.64h-1025.696v-576.96h1025.696v576.96zM961.568 381.792h-897.472v450.752h897.44v-450.752zM865.44 784.48c0 5.664 1.408 10.944 3.232 16h-355.84c88.512 0 160.288-86.080 160.288-192.32s-71.776-192.32-160.288-192.32h355.808c-1.824 5.056-3.232 10.336-3.232 16.032 0 26.56 21.504 48.064 48.064 48.064 5.696 0 10.976-1.408 16.032-3.232v262.88c-5.056-1.792-10.336-3.232-16.032-3.232-26.528 0.032-48.032 21.568-48.032 48.128zM801.312 541.408c-26.56 0-48.064 28.672-48.064 64.096s21.504 64.096 48.064 64.096 48.064-28.672 48.064-64.096-21.504-64.096-48.064-64.096zM579.936 492.608c0.48 0.928 0.864 2.176 1.184 3.712 0.352 1.536 0.576 3.488 0.672 5.824 0.16 2.336 0.224 5.248 0.224 8.736 0 3.872-0.096 7.168-0.288 9.824-0.224 2.688-0.576 4.896-0.992 6.624-0.512 1.76-1.152 3.040-1.984 3.808-0.864 0.8-2.048 1.216-3.52 1.216s-3.776-0.928-7.008-2.784c-3.232-1.888-7.168-3.872-11.808-6.048s-10.080-4.192-16.224-5.984-12.864-2.688-20.224-2.688c-5.76 0-10.752 0.672-15.008 2.080-4.288 1.408-7.872 3.328-10.72 5.792-2.88 2.464-5.024 5.44-6.4 8.864-1.408 3.456-2.112 7.136-2.112 10.976 0 5.76 1.568 10.72 4.704 14.944 3.136 4.192 7.328 7.936 12.64 11.2 5.28 3.296 11.264 6.336 17.92 9.216s13.472 5.92 20.416 9.088c6.944 3.232 13.76 6.848 20.448 10.944 6.688 4.064 12.64 8.928 17.824 14.592 5.216 5.696 9.44 12.352 12.64 20.032s4.8 16.704 4.8 27.136c0 13.6-2.56 25.568-7.616 35.808-5.056 10.272-11.936 18.88-20.64 25.76s-18.816 12.032-30.432 15.488c-1.472 0.448-3.072 0.64-4.576 0.992v35.008h-31.52v-30.88c-0.416 0-0.768 0.096-1.184 0.096-8.928 0-17.248-0.736-24.928-2.176-7.68-1.472-14.464-3.232-20.32-5.248-5.888-2.048-10.784-4.224-14.72-6.464-3.968-2.24-6.784-4.224-8.512-5.952s-2.976-4.224-3.712-7.488-1.12-8-1.12-14.144c0-4.128 0.128-7.616 0.416-10.4 0.256-2.816 0.704-5.088 1.312-6.848 0.608-1.728 1.408-2.976 2.4-3.712 0.992-0.704 2.176-1.088 3.488-1.088 1.888 0 4.512 1.088 7.936 3.328 3.392 2.176 7.776 4.64 13.12 7.296s11.712 5.088 19.136 7.296c7.392 2.208 16 3.328 25.728 3.328 6.4 0 12.16-0.768 17.216-2.304 5.088-1.536 9.376-3.712 12.928-6.496 3.52-2.816 6.208-6.304 8.096-10.432 1.888-4.16 2.816-8.768 2.816-13.856 0-5.888-1.632-10.944-4.8-15.136-3.2-4.224-7.36-7.936-12.512-11.232-5.152-3.264-10.976-6.336-17.504-9.184-6.56-2.88-13.28-5.92-20.224-9.12s-13.696-6.848-20.224-10.912c-6.528-4.064-12.384-8.928-17.504-14.624-5.12-5.664-9.312-12.384-12.512-20.096-3.2-7.744-4.8-17.024-4.8-27.84 0-12.416 2.304-23.328 6.912-32.704 4.608-9.408 10.816-17.216 18.624-23.424 7.808-6.176 17.024-10.848 27.616-13.92 5.44-1.568 11.072-2.72 16.864-3.488v-33.12h31.52v33.12c1.248 0.16 2.496 0.096 3.744 0.288 6.144 0.928 11.904 2.176 17.248 3.776 5.312 1.6 10.048 3.36 14.176 5.376 4.16 1.984 6.88 3.616 8.256 4.96 1.248 1.184 2.144 2.304 2.624 3.264zM352.576 608.16c0 106.208 71.744 192.32 160.256 192.32h-355.808c1.792-5.056 3.232-10.336 3.232-16 0-26.56-21.536-48.096-48.064-48.096-5.696 0-10.976 1.44-16.032 3.232v-262.88c5.056 1.824 10.336 3.232 16.032 3.232 26.56 0 48.064-21.504 48.064-48.064 0-5.696-1.44-10.976-3.232-16.032h355.808c-88.512-0.032-160.256 86.080-160.256 192.288zM224.352 541.408c-26.56 0-48.064 28.672-48.064 64.096s21.536 64.096 48.064 64.096c26.56 0 48.064-28.672 48.064-64.096s-21.504-64.096-48.064-64.096z"
				],
				"width": 1216,
				"attrs": [
					{}
				],
				"isMulticolor": false,
				"isMulticolor2": false,
				"tags": [
					"dollar",
					"bill",
					"money",
					"stack"
				],
				"grid": 32
			},
			"attrs": [
				{}
			],
			"properties": {
				"order": 1,
				"id": 1,
				"prevSize": 32,
				"code": 59675,
				"name": "dollar"
			},
			"setIdx": 0,
			"setId": 6,
			"iconIdx": 1
		},
		{
			"icon": {
				"paths": [
					"M512 801.6l-104-104-24 24 144 144 144-144-24-24-104 104v-353.6h-32v353.6zM624 96h16l192 224v576.295c0 34.963-28.617 63.705-63.918 63.705h-480.165c-35.408 0-63.918-28.759-63.918-64.235v-735.531c0-35.488 28.693-64.235 64.088-64.235h335.912zM608 128h-320.142c-17.595 0-31.858 14.568-31.858 31.855v736.291c0 17.593 14.551 31.855 31.999 31.855h480.003c17.672 0 31.999-14.238 31.999-31.789v-544.211h-128.067c-35.309 0-63.933-28.37-63.933-64.189v-159.811zM640 144v143.719c0 17.828 14.421 32.281 31.896 32.281h118.503l-150.398-176z"
				],
				"attrs": [
					{}
				],
				"isMulticolor": false,
				"isMulticolor2": false,
				"tags": [
					"document-download"
				],
				"grid": 32
			},
			"attrs": [
				{}
			],
			"properties": {
				"order": 1,
				"id": 2,
				"prevSize": 32,
				"code": 59693,
				"name": "document-download"
			},
			"setIdx": 0,
			"setId": 6,
			"iconIdx": 2
		},
		{
			"icon": {
				"paths": [
					"M846.183 388.811l-361.159 361.586-83.378-83.378 361.347-361.398 83.19 83.19zM868.797 366.17l-83.178-83.178 55.274-55.282c12.523-12.525 32.766-12.428 45.33 0.102l37.754 37.65c12.541 12.506 12.633 32.815 0.153 45.309l-55.334 55.399zM380.919 691.546l79.851 79.851-100.317 19.755 20.465-99.606zM704 320v0l-192-224h-351.912c-35.395 0-64.088 28.747-64.088 64.235v735.531c0 35.476 28.51 64.235 63.918 64.235h480.165c35.301 0 63.918-28.743 63.918-63.705v-320.295l242.563-242.563c25.094-25.094 25.155-65.719 0.309-90.565l-37.744-37.744c-24.924-24.924-65.199-25.057-90.565 0.309l-114.563 114.563zM672 608v288.211c0 17.55-14.326 31.789-31.999 31.789h-480.003c-17.448 0-31.999-14.262-31.999-31.855v-736.291c0-17.286 14.264-31.855 31.858-31.855h320.142v159.811c0 35.82 28.624 64.189 63.933 64.189h128.067l-320 320-32 160 160-32 192-192zM512 144l150.398 176h-118.503c-17.475 0-31.896-14.453-31.896-32.281v-143.719z"
				],
				"attrs": [
					{}
				],
				"isMulticolor": false,
				"isMulticolor2": false,
				"tags": [
					"document-edit"
				],
				"grid": 32
			},
			"attrs": [
				{}
			],
			"properties": {
				"order": 1,
				"id": 3,
				"prevSize": 32,
				"code": 59689,
				"name": "document-edit"
			},
			"setIdx": 0,
			"setId": 6,
			"iconIdx": 3
		},
		{
			"icon": {
				"paths": [
					"M972.512 405.76l-98.048-19.648c-4.928-14.176-10.752-27.936-17.184-41.248l55.552-83.328c16.928-25.376 13.568-59.2-8-80.736l-61.568-61.568c-12.384-12.384-28.736-18.752-45.312-18.752-12.256 0-24.64 3.52-35.424 10.752l-83.328 55.52c-13.376-6.464-27.136-12.224-41.312-17.152l-19.648-98.080c-5.952-29.952-32.256-51.456-62.752-51.456h-87.040c-30.496 0-56.768 21.536-62.752 51.456l-19.648 98.080c-14.176 4.928-27.936 10.72-41.248 17.152l-83.296-55.52c-10.848-7.232-23.2-10.752-35.488-10.752-16.544 0-32.896 6.368-45.28 18.752l-61.536 61.568c-21.568 21.568-24.928 55.36-8 80.736l55.52 83.328c-6.464 13.344-12.224 27.104-17.152 41.28l-98.112 19.616c-29.92 5.984-51.456 32.256-51.456 62.752v87.040c0 30.496 21.536 56.8 51.456 62.752l98.080 19.68c4.928 14.176 10.72 27.936 17.152 41.248l-55.488 83.328c-16.928 25.376-13.568 59.2 8 80.736l61.568 61.568c12.384 12.384 28.736 18.752 45.28 18.752 12.288 0 24.672-3.552 35.456-10.752l83.328-55.552c13.344 6.496 27.104 12.256 41.28 17.184l19.616 98.048c5.984 29.952 32.256 51.488 62.752 51.488h87.040c30.496 0 56.8-21.568 62.752-51.488l19.68-98.048c14.176-4.928 27.936-10.752 41.248-17.184l83.328 55.552c10.816 7.2 23.2 10.752 35.424 10.752 16.576 0 32.928-6.368 45.312-18.752l61.568-61.568c21.568-21.568 24.928-55.36 8-80.736l-55.552-83.328c6.496-13.376 12.256-27.136 17.184-41.312l98.048-19.616c29.92-5.92 51.488-32.256 51.488-62.752v-87.040c0-30.496-21.568-56.768-51.488-62.752zM861.888 575.2c-22.24 4.448-40.448 20.32-47.872 41.76-4.128 11.808-8.928 23.264-14.304 34.368-9.952 20.448-8.256 44.576 4.32 63.424l55.552 83.328-61.568 61.568-83.328-55.552c-10.688-7.136-23.072-10.752-35.488-10.752-9.504 0-19.072 2.112-27.872 6.368-11.136 5.376-22.56 10.24-34.432 14.368-21.376 7.424-37.248 25.632-41.696 47.872l-19.68 98.112h-87.040l-19.616-98.112c-4.448-22.24-20.32-40.448-41.728-47.872-11.808-4.128-23.296-8.928-34.4-14.304-8.832-4.32-18.368-6.432-27.904-6.432-12.448 0-24.8 3.616-35.488 10.752l-83.328 55.552-61.568-61.568 55.52-83.328c12.576-18.88 14.208-43.008 4.384-63.36-5.376-11.136-10.208-22.56-14.336-34.432-7.424-21.376-25.664-37.248-47.872-41.696l-98.080-19.68-0.064-87.072 98.112-19.616c22.208-4.448 40.448-20.32 47.872-41.728 4.128-11.808 8.896-23.296 14.304-34.4 9.92-20.416 8.256-44.544-4.352-63.392l-55.488-83.328 61.536-61.568 83.328 55.52c10.688 7.136 23.072 10.752 35.488 10.752 9.504 0 19.040-2.112 27.872-6.368 11.104-5.376 22.56-10.208 34.4-14.336 21.408-7.424 37.28-25.664 41.728-47.872l19.648-98.080 87.040-0.032 19.616 98.112c4.448 22.208 20.32 40.448 41.76 47.872 11.808 4.128 23.264 8.896 34.368 14.304 8.864 4.288 18.368 6.4 27.936 6.4 12.448 0 24.8-3.616 35.488-10.752l83.328-55.52 61.568 61.568-55.552 83.328c-12.576 18.88-14.176 42.976-4.384 63.36 5.376 11.104 10.24 22.56 14.368 34.4 7.424 21.408 25.632 37.28 47.872 41.728l98.048 19.648 0.096 87.040-98.112 19.648zM512 288.032c-123.68 0-224 100.32-224 224 0 123.712 100.32 224 224 224s224-100.32 224-224c0-123.68-100.32-224-224-224zM512 708.064c-108.224 0-196-87.808-196-196 0-108.224 87.776-196 196-196 108.192 0 196 87.776 196 196 0 108.192-87.808 196-196 196zM512 384.032c-70.72 0-128 57.28-128 128 0 70.688 57.28 128 128 128 70.688 0 128-57.312 128-128 0-70.688-57.312-128-128-128zM512 608.064c-52.992 0-96-43.008-96-96 0-52.992 43.008-96 96-96s96 43.008 96 96c0 52.992-43.008 96-96 96z"
				],
				"attrs": [],
				"isMulticolor": false,
				"isMulticolor2": false,
				"tags": [
					"settings",
					"cog",
					"preferences"
				],
				"grid": 32
			},
			"attrs": [],
			"properties": {
				"id": 4,
				"order": 54,
				"prevSize": 32,
				"code": 59656,
				"name": "settings"
			},
			"setIdx": 0,
			"setId": 6,
			"iconIdx": 4
		},
		{
			"icon": {
				"paths": [
					"M800 416v-128c0-159.072-128.928-288-288-288s-288 128.928-288 288v128c-53.024 0-96 42.976-96 96v96 32 64 32c0 159.072 128.928 288 288 288h192c159.072 0 288-128.928 288-288v-32-64-32-96c0-53.056-43.008-96-96-96zM288 288c0-123.712 100.288-224 224-224s224 100.288 224 224v128h-64v-127.936c0-88.384-71.616-160-160-160s-160 71.616-160 160v127.936h-64v-128zM640 288v0.096 127.904h-256v-127.936-0.064c0-70.688 57.312-128 128-128s128 57.312 128 128zM832 608v32 64 32c0 123.488-100.512 224-224 224h-192c-123.488 0-224-100.512-224-224v-32-64-32-96c0-17.664 14.336-32 32-32 21.344 0 42.656 0 64 0h448c21.312 0 42.624 0 64 0 17.632 0 32 14.336 32 32v96zM512 608c35.328 0 64 28.64 64 64 0 19.488-10.496 56.576-21.312 85.824-8.736 23.616-17.664 42.112-42.688 42.112-23.008 0-33.952-18.688-42.656-42.432-10.688-29.184-21.344-66.080-21.344-85.504 0-35.36 28.672-64 64-64z"
				],
				"attrs": [],
				"isMulticolor": false,
				"isMulticolor2": false,
				"tags": [
					"lock",
					"security",
					"private",
					"encryption"
				],
				"grid": 32
			},
			"attrs": [],
			"properties": {
				"id": 5,
				"order": 92,
				"prevSize": 32,
				"code": 59678,
				"name": "lock"
			},
			"setIdx": 0,
			"setId": 6,
			"iconIdx": 5
		},
		{
			"icon": {
				"paths": [
					"M1005.28 338.752l-320-320c-15.872-15.872-38.88-22.24-60.672-16.864-11.488 2.816-21.76 8.736-29.888 16.864-7.264 7.264-12.736 16.256-15.872 26.304-14.496 47.008-39.552 87.872-76.64 124.928-49.536 49.504-114.048 87.008-182.304 126.656-72.448 41.984-147.296 85.504-208.64 146.816-52.128 52.192-87.616 110.24-108.416 177.632-7.008 22.752-0.896 47.36 15.872 64.192l320 320c15.872 15.872 38.88 22.24 60.672 16.864 11.488-2.88 21.76-8.736 29.888-16.864 7.264-7.264 12.736-16.256 15.872-26.368 14.528-47.008 39.584-87.872 76.704-124.928 49.504-49.504 113.984-86.944 182.304-126.56 72.384-42.048 147.264-85.568 208.576-146.88 52.128-52.128 87.616-110.24 108.448-177.632 6.976-22.72 0.832-47.424-15.904-64.16zM384 960c-105.984-105.984-214.016-214.048-320-320 90.944-294.432 485.12-281.568 576-576 105.984 105.952 214.048 214.016 320.064 320-90.976 294.368-485.152 281.568-576.064 576zM625.984 476.8c-10.432-8.736-20.928-14.688-31.488-17.632-10.496-2.944-20.992-4.128-31.616-3.36-10.496 0.8-21.248 3.2-32 7.328-10.752 4.192-21.568 8.736-32.448 14.016-17.184-19.744-34.368-39.264-51.552-57.376 7.744-7.008 15.264-10.56 22.496-10.816 7.264-0.32 14.24 0.448 20.864 2.112 6.752 1.696 12.928 3.136 18.624 4.256 5.76 1.12 10.752-0.128 15.136-3.808 4.64-4 7.2-9.184 7.552-15.424 0.32-6.304-2.048-12.448-7.328-18.432-6.752-7.744-14.88-12.448-24.64-14.176-9.632-1.696-19.488-1.568-29.76 0.672-10.112 2.304-19.744 6.112-28.864 11.488s-16.448 10.88-21.888 16.256c-2.080-1.984-4.16-3.936-6.24-5.888-2.304-2.112-5.184-3.264-8.64-3.2-3.488 0-6.368 1.504-8.736 4.256-2.304 2.688-3.36 5.824-2.944 9.12 0.32 3.424 1.696 6.048 4.064 8.064 2.080 1.76 4.16 3.488 6.24 5.312-8.192 9.888-14.944 20.8-20.256 32.32-5.376 11.552-8.576 23.008-9.76 34.112-1.248 11.2-0.064 21.44 3.36 30.944 3.424 9.568 9.76 17.696 19.008 25.376 15.072 12.512 32.8 17.824 53.376 16.64 20.512-1.248 42.624-7.36 66.4-20.128 18.88 21.824 37.824 43.488 56.736 63.616-8 6.752-15.008 10.624-21.184 11.872-6.176 1.312-11.68 1.184-16.672-0.32-4.992-1.568-9.632-3.808-13.888-6.688-4.256-2.944-8.448-5.44-12.64-7.488-4.128-2.048-8.384-3.2-12.736-3.264s-8.992 2.048-14.112 6.432c-5.248 4.576-7.872 9.888-7.872 15.872 0 5.952 2.752 12 8.128 18.112 5.44 6.112 12.512 11.264 21.056 15.328s18.208 6.624 28.832 7.328c10.624 0.736 21.824-0.864 33.632-5.248 11.872-4.32 23.616-12.128 35.2-23.744 5.568 5.44 11.2 10.624 16.8 15.616 2.368 2.048 5.248 3.072 8.736 2.816 3.36-0.128 6.304-1.696 8.64-4.512 2.368-2.88 3.36-6.048 3.008-9.376-0.32-3.36-1.696-5.952-4-7.808-5.632-4.512-11.264-9.248-16.864-14.24 9.568-11.744 17.248-24.128 22.944-36.384 5.696-12.32 9.056-24.192 10.176-35.2 1.12-11.072-0.192-21.056-3.808-30.112-3.584-9.184-9.952-17.056-19.072-24.64zM447.072 498.496c-9.056 0.384-16.96-2.624-23.872-9.312-2.944-2.816-4.992-6.24-6.24-10.304-1.312-4.064-1.76-8.512-1.248-13.376 0.448-4.8 1.888-9.824 4.384-14.88 2.368-5.056 5.888-10.112 10.368-15.008 16.224 16.128 32.416 33.824 48.64 52.128-12.288 6.752-22.976 10.368-32.032 10.752zM598.016 562.56c-2.88 5.312-6.176 10.048-10.048 14.176-17.952-18.112-35.872-38.016-53.76-58.432 4.576-2.048 9.376-4.192 14.56-6.368s10.368-3.616 15.552-4.512c5.312-0.8 10.56-0.576 15.808 0.672 5.184 1.312 10.112 4.128 14.688 8.576 4.512 4.512 7.36 9.184 8.512 14.24 1.248 5.12 1.312 10.304 0.448 15.616-0.928 5.344-2.816 10.656-5.76 16.032zM470.944 709.76c6.304-5.088 15.584-4.832 21.376 1.056 6.272 6.24 6.272 16.448 0 22.688-0.512 0.512-1.056 0.864-1.632 1.312l0.064 0.064c-20.256 15.392-36.896 29.248-54.848 47.2-16.224 16.192-30.88 33.248-43.552 50.56l-20.448 28c-0.64 1.152-1.408 2.208-2.368 3.2-6.272 6.24-16.48 6.24-22.72 0-5.44-5.44-6.112-13.824-2.112-20.064l-0.064-0.064 21.888-29.888c13.664-18.688 29.376-36.992 46.752-54.368 18.080-18.144 37.6-34.336 57.6-49.696h0.064zM588.096 246.88c16.192-16.192 30.816-33.184 43.52-50.592l21.248-29.12c0.768-1.376 1.632-2.752 2.816-3.936 6.304-6.304 16.512-6.304 22.816 0 5.984 6.016 6.24 15.52 0.8 21.888l0.064 0.064-21.888 30.016c-13.696 18.688-29.376 36.928-46.752 54.304-18.080 18.080-37.568 34.336-57.568 49.696l-0.128-0.064c-6.368 5.856-16.256 5.728-22.368-0.448-6.304-6.304-6.304-16.576 0-22.88 1.12-1.184 2.432-2.016 3.744-2.752 18.816-14.368 36.96-29.44 53.696-46.176z"
				],
				"attrs": [],
				"isMulticolor": false,
				"isMulticolor2": false,
				"tags": [
					"banknote",
					"check",
					"bill",
					"money",
					"cash"
				],
				"grid": 32
			},
			"attrs": [],
			"properties": {
				"id": 6,
				"order": 111,
				"prevSize": 32,
				"code": 59657,
				"name": "banknote"
			},
			"setIdx": 0,
			"setId": 6,
			"iconIdx": 6
		},
		{
			"icon": {
				"paths": [
					"M938.688 96h-138.688v-64c0-17.696-14.304-32-32-32s-32 14.304-32 32v64h-192v-64c0-17.696-14.336-32-32-32s-32 14.304-32 32v64h-192v-64c0-17.696-14.336-32-32-32s-32 14.304-32 32v64h-138.656c-47.136 0-85.344 38.176-85.344 85.312v757.344c0 47.136 38.208 85.344 85.344 85.344h853.344c47.136 0 85.312-38.208 85.312-85.344v-757.344c0-47.136-38.176-85.312-85.312-85.312zM960 938.656c0 11.776-9.568 21.344-21.312 21.344h-853.344c-11.776 0-21.344-9.568-21.344-21.344v-757.344c0-11.744 9.568-21.312 21.344-21.312h138.656v64c0 17.696 14.336 32 32 32s32-14.304 32-32v-64h192v64c0 17.696 14.336 32 32 32s32-14.304 32-32v-64h192v64c0 17.696 14.304 32 32 32s32-14.304 32-32v-64h138.688c11.744 0 21.312 9.568 21.312 21.312v757.344zM224 384h128v96h-128zM224 544h128v96h-128zM224 704h128v96h-128zM448 704h128v96h-128zM448 544h128v96h-128zM448 384h128v96h-128zM672 704h128v96h-128zM672 544h128v96h-128zM672 384h128v96h-128z"
				],
				"attrs": [],
				"isMulticolor": false,
				"isMulticolor2": false,
				"tags": [
					"calendar",
					"date",
					"schedule"
				],
				"grid": 32
			},
			"attrs": [],
			"properties": {
				"id": 7,
				"order": 41,
				"prevSize": 32,
				"code": 59652,
				"name": "calendar"
			},
			"setIdx": 0,
			"setId": 6,
			"iconIdx": 7
		},
		{
			"icon": {
				"paths": [
					"M512 640c0-35.346 28.654-64 64-64s64 28.654 64 64c0 35.346-28.654 64-64 64-35.346 0-64-28.654-64-64zM928.032 416c-0.032 0-0.032 0 0 0l-0.032-192v-16-80c0-53.024-43.008-96-96-96h-128-528c-97.056 0-176 78.976-176 176v640c0 97.024 78.944 176 176 176h576c97.024 0 176-78.976 176-176v-48c0 0 0 0 0.032 0 127.936-96.032 127.936-287.968 0-384zM176 96h656c17.632 0 32 14.336 32 32v80 16 101.888c-10.048-3.584-20.736-5.888-32-5.888h-0.032v-32-64-64c0-17.696-14.336-32-32-32h-672c-17.664 0-32 14.304-32 32v64 62.176c-19.744-20.192-31.968-47.712-31.968-78.176 0-61.856 50.112-112 112-112zM799.968 192h-672l0-32h672v32zM799.968 224v32h-672l0-32h672zM799.968 288v32h-623.968c-17.28 0-33.408-4.224-48-11.2v-20.8h671.968zM864 848c0 61.856-50.144 112-112 112h-576c-61.888 0-112-50.144-112-112v-504.352c30.432 25.184 69.472 40.352 112 40.352h528 128c17.632 0 32 14.336 32 32v64h-288c-88.384 0-160 71.616-160 160s71.648 160 160 160h288v48zM904.864 736h-328.864c-52.928 0-96-43.072-96-96s43.072-96 96-96h288c19.744-0.256 39.328-9.824 51.264-25.728 3.328-4.48 5.92-9.504 8-14.752 0.288-0.704 0.8-1.248 1.056-1.984 23.008 30.176 35.68 67.168 35.68 106.464 0 49.216-19.872 94.88-55.136 128z"
				],
				"attrs": [],
				"isMulticolor": false,
				"isMulticolor2": false,
				"tags": [
					"wallet",
					"money",
					"cash"
				],
				"grid": 32
			},
			"attrs": [],
			"properties": {
				"id": 8,
				"order": 42,
				"prevSize": 32,
				"code": 59653,
				"name": "wallet"
			},
			"setIdx": 0,
			"setId": 6,
			"iconIdx": 8
		},
		{
			"icon": {
				"paths": [
					"M588 648l90-92 256 256-90 92zM746 426q42 0 76-20t54-54 20-74q0-20-5-37t-13-31l-114 114-64-64 114-114q-14-8-31-13t-37-5q-40 0-74 20t-54 54-20 76q0 24 8 48l-78 80-76-76 30-30-60-60 90-92q-24-24-57-32t-66 0-57 32l-152 152 60 60h-120l-30 30 150 152 30-30v-122l62 60 30-30 76 76-316 316 90 90 486-484q24 8 48 8z"
				],
				"attrs": [
					{}
				],
				"isMulticolor": false,
				"isMulticolor2": false,
				"tags": [
					"construction"
				],
				"grid": 24
			},
			"attrs": [
				{}
			],
			"properties": {
				"order": 1,
				"id": 0,
				"prevSize": 24,
				"code": 59663,
				"name": "construction"
			},
			"setIdx": 1,
			"setId": 5,
			"iconIdx": 0
		},
		{
			"icon": {
				"paths": [
					"M128 256h768v86h-768v-86zM128 554v-84h768v84h-768zM128 768v-86h768v86h-768z"
				],
				"attrs": [
					{}
				],
				"isMulticolor": false,
				"isMulticolor2": false,
				"tags": [
					"menu"
				],
				"grid": 24
			},
			"attrs": [
				{}
			],
			"properties": {
				"order": 1,
				"id": 1,
				"prevSize": 24,
				"code": 59683,
				"name": "menu"
			},
			"setIdx": 1,
			"setId": 5,
			"iconIdx": 1
		},
		{
			"icon": {
				"paths": [
					"M938 470h-298v-128h-86v340h86v-128h298v342h-298v-128h-170v-426h-86v128h-298v-342h298v128h256v-128h298v342z"
				],
				"attrs": [
					{}
				],
				"isMulticolor": false,
				"isMulticolor2": false,
				"tags": [
					"account_tree"
				],
				"grid": 24
			},
			"attrs": [
				{}
			],
			"properties": {
				"order": 1,
				"id": 2,
				"name": "account_tree",
				"prevSize": 24,
				"code": 59679
			},
			"setIdx": 1,
			"setId": 5,
			"iconIdx": 2
		},
		{
			"icon": {
				"paths": [
					"M780.501 183.168l-597.333 597.333c-16.683 16.683-16.683 43.691 0 60.331s43.691 16.683 60.331 0l597.333-597.333c16.683-16.683 16.683-43.691 0-60.331s-43.691-16.683-60.331 0zM426.667 277.333c0-41.216-16.768-78.635-43.733-105.6s-64.384-43.733-105.6-43.733-78.635 16.768-105.6 43.733-43.733 64.384-43.733 105.6 16.768 78.635 43.733 105.6 64.384 43.733 105.6 43.733 78.635-16.768 105.6-43.733 43.733-64.384 43.733-105.6zM341.333 277.333c0 17.664-7.125 33.621-18.731 45.269s-27.605 18.731-45.269 18.731-33.621-7.125-45.269-18.731-18.731-27.605-18.731-45.269 7.125-33.621 18.731-45.269 27.605-18.731 45.269-18.731 33.621 7.125 45.269 18.731 18.731 27.605 18.731 45.269zM896 746.667c0-41.216-16.768-78.635-43.733-105.6s-64.384-43.733-105.6-43.733-78.635 16.768-105.6 43.733-43.733 64.384-43.733 105.6 16.768 78.635 43.733 105.6 64.384 43.733 105.6 43.733 78.635-16.768 105.6-43.733 43.733-64.384 43.733-105.6zM810.667 746.667c0 17.664-7.125 33.621-18.731 45.269s-27.605 18.731-45.269 18.731-33.621-7.125-45.269-18.731-18.731-27.605-18.731-45.269 7.125-33.621 18.731-45.269 27.605-18.731 45.269-18.731 33.621 7.125 45.269 18.731 18.731 27.605 18.731 45.269z"
				],
				"attrs": [
					{}
				],
				"isMulticolor": false,
				"isMulticolor2": false,
				"tags": [
					"percent"
				],
				"grid": 24
			},
			"attrs": [
				{}
			],
			"properties": {
				"order": 1,
				"id": 3,
				"prevSize": 24,
				"code": 59686,
				"name": "percent"
			},
			"setIdx": 1,
			"setId": 5,
			"iconIdx": 3
		},
		{
			"icon": {
				"paths": [
					"M846.72 170.667l-281.984 333.397c-6.272 7.381-10.069 17.024-10.069 27.563v295.339l-85.333-42.667v-252.672c0.043-9.685-3.285-19.499-10.069-27.563l-281.984-333.397zM938.667 85.333h-853.333c-23.552 0-42.667 19.115-42.667 42.667 0 10.539 3.797 20.181 10.069 27.563l331.264 391.68v263.424c0 16.597 9.472 31.019 23.595 38.144l170.667 85.333c21.077 10.539 46.72 2.005 57.259-19.072 3.072-6.229 4.523-12.843 4.48-19.072v-348.757l331.264-391.68c15.232-18.005 12.971-44.928-5.035-60.117-8.064-6.827-17.877-10.155-27.563-10.112z"
				],
				"attrs": [
					{}
				],
				"isMulticolor": false,
				"isMulticolor2": false,
				"tags": [
					"filter"
				],
				"grid": 24
			},
			"attrs": [
				{}
			],
			"properties": {
				"order": 1,
				"id": 4,
				"prevSize": 24,
				"code": 59671,
				"name": "filter"
			},
			"setIdx": 1,
			"setId": 5,
			"iconIdx": 4
		},
		{
			"icon": {
				"paths": [
					"M563.2 460.8h204.8v102.4h-204.8v204.8h-102.4v-204.8h-204.8v-102.4h204.8v-204.8h102.4v204.8zM512 1024c-282.77 0-512-229.23-512-512s229.23-512 512-512v0c282.77 0 512 229.23 512 512s-229.23 512-512 512v0zM512 921.6c226.216 0 409.6-183.384 409.6-409.6s-183.384-409.6-409.6-409.6v0c-226.216 0-409.6 183.384-409.6 409.6s183.384 409.6 409.6 409.6v0z"
				],
				"attrs": [],
				"isMulticolor": false,
				"isMulticolor2": false,
				"tags": [
					"add-outline"
				],
				"grid": 20
			},
			"attrs": [],
			"properties": {
				"id": 0,
				"order": 90,
				"prevSize": 20,
				"code": 59674,
				"name": "add-outline"
			},
			"setIdx": 2,
			"setId": 4,
			"iconIdx": 0
		},
		{
			"icon": {
				"paths": [
					"M51.2 51.2h921.6v102.4h-921.6v-102.4zM51.2 460.8h921.6v102.4h-921.6v-102.4zM51.2 870.4h921.6v102.4h-921.6v-102.4zM51.2 256h921.6v102.4h-921.6v-102.4zM51.2 665.6h921.6v102.4h-921.6v-102.4z"
				],
				"attrs": [],
				"isMulticolor": false,
				"isMulticolor2": false,
				"tags": [
					"align-justified"
				],
				"grid": 20
			},
			"attrs": [],
			"properties": {
				"id": 1,
				"order": 66,
				"prevSize": 20,
				"code": 59662,
				"name": "align-justified"
			},
			"setIdx": 2,
			"setId": 4,
			"iconIdx": 1
		},
		{
			"icon": {
				"paths": [
					"M102.4 102.4c0-56.32 46.080-102.4 102.4-102.4h614.4c56.554 0 102.4 45.846 102.4 102.4v0 819.2c0 56.554-45.846 102.4-102.4 102.4v0h-614.4c-56.554 0-102.4-45.846-102.4-102.4v0-819.2zM256 153.6v102.4h512v-102.4h-512zM256 358.4v102.4h102.4v-102.4h-102.4zM460.8 358.4v102.4h102.4v-102.4h-102.4zM665.6 358.4v102.4h102.4v-102.4h-102.4zM256 563.2v102.4h102.4v-102.4h-102.4zM460.8 563.2v102.4h102.4v-102.4h-102.4zM665.6 563.2v307.2h102.4v-307.2h-102.4zM256 768v102.4h102.4v-102.4h-102.4zM460.8 768v102.4h102.4v-102.4h-102.4z"
				],
				"attrs": [],
				"isMulticolor": false,
				"isMulticolor2": false,
				"tags": [
					"calculator"
				],
				"grid": 20
			},
			"attrs": [],
			"properties": {
				"id": 2,
				"order": 108,
				"prevSize": 20,
				"code": 59688,
				"name": "calculator"
			},
			"setIdx": 2,
			"setId": 4,
			"iconIdx": 2
		},
		{
			"icon": {
				"paths": [
					"M51.2 204.8c0-56.32 46.080-102.4 102.4-102.4h716.8c56.554 0 102.4 45.846 102.4 102.4v0 716.8c0 56.554-45.846 102.4-102.4 102.4v0h-716.8c-56.554 0-102.4-45.846-102.4-102.4v0-716.8zM153.6 307.2v614.4h716.8v-614.4h-716.8zM256 0h102.4v102.4h-102.4v-102.4zM665.6 0h102.4v102.4h-102.4v-102.4zM256 460.8h102.4v102.4h-102.4v-102.4zM256 665.6h102.4v102.4h-102.4v-102.4zM460.8 460.8h102.4v102.4h-102.4v-102.4zM460.8 665.6h102.4v102.4h-102.4v-102.4zM665.6 460.8h102.4v102.4h-102.4v-102.4zM665.6 665.6h102.4v102.4h-102.4v-102.4z"
				],
				"attrs": [],
				"isMulticolor": false,
				"isMulticolor2": false,
				"tags": [
					"calendar"
				],
				"grid": 20
			},
			"attrs": [],
			"properties": {
				"id": 3,
				"order": 61,
				"prevSize": 20,
				"code": 59660,
				"name": "calendar1"
			},
			"setIdx": 2,
			"setId": 4,
			"iconIdx": 3
		},
		{
			"icon": {
				"paths": [
					"M0 563.2l102.4-102.4 256 256 563.2-563.2 102.4 102.4-665.6 665.6z"
				],
				"attrs": [],
				"isMulticolor": false,
				"isMulticolor2": false,
				"tags": [
					"checkmark"
				],
				"grid": 20
			},
			"attrs": [],
			"properties": {
				"id": 4,
				"order": 59,
				"prevSize": 20,
				"code": 59659,
				"name": "checkmark"
			},
			"setIdx": 2,
			"setId": 4,
			"iconIdx": 4
		},
		{
			"icon": {
				"paths": [
					"M475.802 663.040l36.198 36.198 289.638-289.638-72.397-72.397-217.242 217.19-217.242-217.19-72.397 72.397z"
				],
				"attrs": [],
				"isMulticolor": false,
				"isMulticolor2": false,
				"tags": [
					"cheveron-down"
				],
				"grid": 20
			},
			"attrs": [],
			"properties": {
				"id": 5,
				"order": 36,
				"prevSize": 20,
				"code": 59649,
				"name": "cheveron-down"
			},
			"setIdx": 2,
			"setId": 4,
			"iconIdx": 5
		},
		{
			"icon": {
				"paths": [
					"M548.198 360.96l-36.198-36.198-289.638 289.638 72.397 72.397 217.242-217.19 217.242 217.19 72.397-72.397z"
				],
				"attrs": [],
				"isMulticolor": false,
				"isMulticolor2": false,
				"tags": [
					"cheveron-up"
				],
				"grid": 20
			},
			"attrs": [],
			"properties": {
				"id": 6,
				"order": 65,
				"prevSize": 20,
				"code": 59661,
				"name": "cheveron-up"
			},
			"setIdx": 2,
			"setId": 4,
			"iconIdx": 6
		},
		{
			"icon": {
				"paths": [
					"M512 439.603l-362.035-362.035-72.397 72.397 362.035 362.035-362.035 362.035 72.397 72.397 362.035-362.035 362.035 362.035 72.397-72.397-362.035-362.035 362.035-362.035-72.397-72.397-362.035 362.035z"
				],
				"attrs": [],
				"isMulticolor": false,
				"isMulticolor2": false,
				"tags": [
					"close"
				],
				"grid": 20
			},
			"attrs": [],
			"properties": {
				"id": 7,
				"order": 97,
				"prevSize": 20,
				"code": 59681,
				"name": "close"
			},
			"setIdx": 2,
			"setId": 4,
			"iconIdx": 7
		},
		{
			"icon": {
				"paths": [
					"M150.016 873.984c-96.436-93.233-156.308-223.762-156.308-368.276 0-282.77 229.23-512 512-512 144.514 0 275.043 59.872 368.137 156.164l0.138 0.144c88.925 91.979 143.724 217.436 143.724 355.692 0 282.77-229.23 512-512 512-138.256 0-263.713-54.799-355.836-143.863l0.144 0.138zM222.208 801.792c74.164 74.164 176.621 120.036 289.792 120.036 226.342 0 409.828-183.486 409.828-409.828 0-113.171-45.872-215.628-120.036-289.792l-0-0c-74.164-74.164-176.621-120.036-289.792-120.036-226.342 0-409.828 183.486-409.828 409.828 0 113.171 45.872 215.628 120.036 289.792l-0-0zM729.088 367.104l-144.896 144.896 144.896 144.896-72.192 72.192-144.896-144.896-144.896 144.896-72.192-72.192 144.896-144.896-144.896-144.896 72.192-72.192 144.896 144.896 144.896-144.896 72.192 72.192z"
				],
				"attrs": [],
				"isMulticolor": false,
				"isMulticolor2": false,
				"tags": [
					"close-outline"
				],
				"grid": 20
			},
			"attrs": [],
			"properties": {
				"id": 8,
				"order": 76,
				"prevSize": 20,
				"code": 59670,
				"name": "close-outline"
			},
			"setIdx": 2,
			"setId": 4,
			"iconIdx": 8
		},
		{
			"icon": {
				"paths": [
					"M921.6 102.4c56.554 0 102.4 45.846 102.4 102.4v0 614.4c0 56.554-45.846 102.4-102.4 102.4v0h-819.2c-56.554 0-102.4-45.846-102.4-102.4v0-614.4c0-56.32 46.080-102.4 102.4-102.4h819.2zM697.856 568.32l326.144 250.88v-102.4l-262.144-199.68 262.144-209.92v-102.4l-512 409.6-512-409.6v102.4l262.144 209.92-262.144 199.68v102.4l326.144-250.88 185.856 148.48 185.856-148.48z"
				],
				"attrs": [],
				"isMulticolor": false,
				"isMulticolor2": false,
				"tags": [
					"envelope"
				],
				"grid": 20
			},
			"attrs": [],
			"properties": {
				"id": 9,
				"order": 84,
				"prevSize": 20,
				"code": 59672,
				"name": "envelope"
			},
			"setIdx": 2,
			"setId": 4,
			"iconIdx": 9
		},
		{
			"icon": {
				"paths": [
					"M512 1024c-282.77 0-512-229.23-512-512s229.23-512 512-512v0c282.77 0 512 229.23 512 512s-229.23 512-512 512v0zM614.4 358.4c0 14.336-10.752 40.96-21.504 51.2l-80.896 80.896c-29.184 29.696-51.2 81.92-51.2 123.904v51.2h102.4v-51.2c0-14.848 10.752-40.96 21.504-51.2l80.896-80.896c29.184-29.696 51.2-81.92 51.2-123.904 0-113.108-91.692-204.8-204.8-204.8s-204.8 91.692-204.8 204.8v0h102.4c0-56.554 45.846-102.4 102.4-102.4s102.4 45.846 102.4 102.4v0zM460.8 768v102.4h102.4v-102.4h-102.4z"
				],
				"attrs": [],
				"isMulticolor": false,
				"isMulticolor2": false,
				"tags": [
					"question"
				],
				"grid": 20
			},
			"attrs": [],
			"properties": {
				"id": 10,
				"order": 99,
				"prevSize": 20,
				"code": 59684,
				"name": "question"
			},
			"setIdx": 2,
			"setId": 4,
			"iconIdx": 10
		},
		{
			"icon": {
				"paths": [
					"M204.8 512c0-56.32 46.080-102.4 102.4-102.4h409.6c56.32 0 102.4 46.080 102.4 102.4v409.6c0 56.32-46.080 102.4-102.4 102.4h-409.6c-56.32 0-102.4-46.080-102.4-102.4v-409.6zM307.2 512v409.6h409.6v-409.6h-102.4v-102.4h-204.8v102.4h-102.4zM460.8 196.096v623.104h102.4v-623.104l157.184 157.184 72.704-72.192-281.088-281.088-281.6 281.6 72.704 71.68 157.696-156.672z"
				],
				"attrs": [],
				"isMulticolor": false,
				"isMulticolor2": false,
				"tags": [
					"share"
				],
				"grid": 20
			},
			"attrs": [],
			"properties": {
				"id": 11,
				"order": 46,
				"prevSize": 20,
				"code": 59654,
				"name": "share"
			},
			"setIdx": 2,
			"setId": 4,
			"iconIdx": 11
		},
		{
			"icon": {
				"paths": [
					"M260.096 622.592c-27.575 26.972-65.35 43.615-107.012 43.615-84.548 0-153.088-68.54-153.088-153.088 0-0.393 0.001-0.787 0.004-1.179l-0 0.060c0.054-84.79 68.802-153.505 153.6-153.505 41.373 0 78.926 16.358 106.544 42.959l-0.048-0.046 457.728-228.864c-0.768-5.77-1.206-12.441-1.206-19.214 0-84.831 68.769-153.6 153.6-153.6s153.6 68.769 153.6 153.6c0 84.831-68.769 153.6-153.6 153.6-41.285 0-78.765-16.288-106.366-42.788l0.052 0.050-457.728 228.864c0.739 5.688 1.161 12.267 1.161 18.944s-0.422 13.256-1.24 19.711l0.079-0.767 457.728 228.864c27.575-26.972 65.35-43.615 107.012-43.615 84.548 0 153.088 68.54 153.088 153.088 0 0.393-0.001 0.787-0.004 1.179l0-0.060c-0.727 84.277-69.215 152.316-153.595 152.316-84.831 0-153.6-68.769-153.6-153.6 0-6.223 0.37-12.36 1.089-18.389l-0.071 0.729-457.728-228.864z"
				],
				"attrs": [],
				"isMulticolor": false,
				"isMulticolor2": false,
				"tags": [
					"share-alt"
				],
				"grid": 20
			},
			"attrs": [],
			"properties": {
				"id": 12,
				"order": 110,
				"prevSize": 20,
				"code": 59690,
				"name": "share-alt"
			},
			"setIdx": 2,
			"setId": 4,
			"iconIdx": 12
		},
		{
			"icon": {
				"paths": [
					"M212.992 212.992l72.704 72.704c-81.127 66.138-132.521 166.076-132.521 278.017 0 197.656 160.232 357.888 357.888 357.888 0.329 0 0.659-0 0.988-0.001l-0.051 0c197.722-0.287 357.896-160.638 357.896-358.4 0-111.594-51.003-211.277-130.969-277.008l-0.622-0.496 72.704-72.704c99.127 85.029 161.536 210.425 161.536 350.396 0 254.493-206.307 460.8-460.8 460.8s-460.8-206.307-460.8-460.8c0-139.972 62.408-265.367 160.917-349.878l0.619-0.518zM460.8 0h102.4v409.6h-102.4v-409.6z"
				],
				"attrs": [],
				"isMulticolor": false,
				"isMulticolor2": false,
				"tags": [
					"stand-by"
				],
				"grid": 20
			},
			"attrs": [],
			"properties": {
				"id": 13,
				"order": 37,
				"prevSize": 20,
				"code": 59650,
				"name": "stand-by"
			},
			"setIdx": 2,
			"setId": 4,
			"iconIdx": 13
		},
		{
			"icon": {
				"paths": [
					"M512 768l-300.954 158.208 57.498-335.104-243.507-237.312 336.486-48.896 150.477-304.896 150.477 304.896 336.486 48.896-243.507 237.312 57.498 335.104z"
				],
				"attrs": [],
				"isMulticolor": false,
				"isMulticolor2": false,
				"tags": [
					"star-full"
				],
				"grid": 20
			},
			"attrs": [],
			"properties": {
				"id": 14,
				"order": 47,
				"prevSize": 20,
				"code": 59655,
				"name": "star-full"
			},
			"setIdx": 2,
			"setId": 4,
			"iconIdx": 14
		},
		{
			"icon": {
				"paths": [
					"M921.6 505.344v518.656h-819.2v-518.656c15.389 3.889 33.056 6.12 51.245 6.12 37.467 0 72.723-9.469 103.504-26.146l-1.149 0.569v230.912h512v-230.4c29.492 15.869 64.538 25.194 101.761 25.194 18.402 0 36.272-2.279 53.343-6.57l-1.505 0.32zM153.6 0h204.8l-34.304 308.736c-11.832 85.147-83.292 150.251-170.311 152.061l-0.185 0.003c-84.992 0-132.096-65.024-104.96-145.92l104.96-314.88zM409.6 0h204.8l35.84 322.56c8.704 76.8-46.592 138.24-123.904 138.24h-28.672c-0.941 0.026-2.049 0.041-3.16 0.041-67.299 0-121.856-54.557-121.856-121.856 0-5.793 0.404-11.491 1.186-17.068l-0.074 0.643 35.84-322.56zM665.6 0h204.8l104.96 314.88c27.136 80.896-20.48 145.92-104.96 145.92-87.29-1.589-158.873-66.812-170.394-151.155l-0.102-0.909-34.304-308.736z"
				],
				"attrs": [],
				"isMulticolor": false,
				"isMulticolor2": false,
				"tags": [
					"store-front"
				],
				"grid": 20
			},
			"attrs": [],
			"properties": {
				"id": 15,
				"order": 103,
				"prevSize": 20,
				"code": 59687,
				"name": "store-front"
			},
			"setIdx": 2,
			"setId": 4,
			"iconIdx": 15
		},
		{
			"icon": {
				"paths": [
					"M512 1024c-282.77 0-512-229.23-512-512s229.23-512 512-512v0c282.77 0 512 229.23 512 512s-229.23 512-512 512v0zM512 921.6c226.216 0 409.6-183.384 409.6-409.6s-183.384-409.6-409.6-409.6v0c-226.216 0-409.6 183.384-409.6 409.6s183.384 409.6 409.6 409.6v0zM460.8 532.992v-328.192h102.4v286.208l202.24 202.24-72.192 72.192-232.448-232.448z"
				],
				"attrs": [],
				"isMulticolor": false,
				"isMulticolor2": false,
				"tags": [
					"time"
				],
				"grid": 20
			},
			"attrs": [],
			"properties": {
				"id": 16,
				"order": 38,
				"prevSize": 20,
				"code": 59651,
				"name": "time"
			},
			"setIdx": 2,
			"setId": 4,
			"iconIdx": 16
		},
		{
			"icon": {
				"paths": [
					"M256 256c0-141.385 114.615-256 256-256s256 114.615 256 256v0 102.4c0 141.385-114.615 256-256 256s-256-114.615-256-256v0-102.4zM0 854.016c146.431-86.26 322.601-137.217 510.673-137.217 0.466 0 0.933 0 1.399 0.001l-0.072-0c186.368 0 361.472 49.664 512 137.216v169.984h-1024v-169.984z"
				],
				"attrs": [],
				"isMulticolor": false,
				"isMulticolor2": false,
				"tags": [
					"user"
				],
				"grid": 20
			},
			"attrs": [],
			"properties": {
				"id": 17,
				"order": 48,
				"prevSize": 20,
				"code": 59658,
				"name": "user"
			},
			"setIdx": 2,
			"setId": 4,
			"iconIdx": 17
		},
		{
			"icon": {
				"paths": [
					"M358.4 409.6c-113.108 0-204.8-91.692-204.8-204.8s91.692-204.8 204.8-204.8v0c113.108 0 204.8 91.692 204.8 204.8s-91.692 204.8-204.8 204.8v0zM358.4 460.8c110.080 0 215.040 20.48 312.32 55.808l-56.32 302.592h-64l-38.4 204.8h-307.2l-38.4-204.8h-64l-56.32-302.592c92.835-35.013 200.137-55.444 312.164-55.808l0.156-0zM783.872 469.504c67.584 9.216 132.608 24.576 194.56 47.104l-56.832 302.592h-64l-38.4 204.8h-202.752l18.944-102.4h64l84.48-452.096zM665.6 0c0.522-0.005 1.138-0.008 1.756-0.008 113.108 0 204.8 91.692 204.8 204.8s-91.692 204.8-204.8 204.8c-25.063 0-49.074-4.502-71.269-12.741l1.417 0.461c42.583-52.050 68.389-119.268 68.389-192.512s-25.805-140.462-68.82-193.056l0.431 0.544c22.016-7.168 44.032-12.288 68.096-12.288z"
				],
				"attrs": [],
				"isMulticolor": false,
				"isMulticolor2": false,
				"tags": [
					"user-group"
				],
				"grid": 20
			},
			"attrs": [],
			"properties": {
				"id": 18,
				"order": 95,
				"prevSize": 20,
				"code": 59680,
				"name": "user-group"
			},
			"setIdx": 2,
			"setId": 4,
			"iconIdx": 18
		},
		{
			"icon": {
				"paths": [
					"M992 128h-960c-17.664 0-32 14.336-32 32v704c0 17.696 14.336 32 32 32h960c17.696 0 32-14.304 32-32v-704c0-17.664-14.304-32-32-32zM960 800c0 17.696-14.304 32-32 32h-832c-17.664 0-32-14.304-32-32v-576c0-17.664 14.336-32 32-32h832c17.696 0 32 14.336 32 32v576zM303.936 388.512l-123.36-123.392c-12-12-31.456-12-43.456 0s-12 31.456 0 43.456l107.456 107.424-107.456 107.456c-12 12-12 31.424 0 43.424s31.456 12 43.456 0l123.36-123.36c2.432-1.344 4.896-2.56 6.944-4.608 6.304-6.304 9.12-14.656 8.768-22.912 0.32-8.256-2.464-16.608-8.768-22.88-2.048-2.048-4.512-3.264-6.944-4.608zM608 512h-192c-17.664 0-32 14.336-32 32 0 17.696 14.336 32 32 32h192c17.696 0 32-14.304 32-32 0-17.664-14.304-32-32-32z"
				],
				"attrs": [
					{}
				],
				"isMulticolor": false,
				"isMulticolor2": false,
				"tags": [
					"console",
					"command line"
				],
				"grid": 16
			},
			"attrs": [
				{}
			],
			"properties": {
				"order": 1,
				"id": 0,
				"name": "console, command-line",
				"prevSize": 32,
				"code": 59677
			},
			"setIdx": 3,
			"setId": 3,
			"iconIdx": 0
		},
		{
			"icon": {
				"paths": [
					"M1024 590.444l-512-397.426-512 397.428v-162.038l512-397.426 512 397.428zM896 576v384h-256v-256h-256v256h-256v-384l384-288z"
				],
				"attrs": [],
				"isMulticolor": false,
				"isMulticolor2": false,
				"tags": [
					"home",
					"house"
				],
				"defaultCode": 59648,
				"grid": 16
			},
			"attrs": [],
			"properties": {
				"ligatures": "home, house",
				"name": "home",
				"order": 34,
				"id": 1,
				"prevSize": 32,
				"code": 59648
			},
			"setIdx": 3,
			"setId": 3,
			"iconIdx": 1
		},
		{
			"icon": {
				"paths": [
					"M0 1024h512v-1024h-512v1024zM320 128h128v128h-128v-128zM320 384h128v128h-128v-128zM320 640h128v128h-128v-128zM64 128h128v128h-128v-128zM64 384h128v128h-128v-128zM64 640h128v128h-128v-128zM576 320h448v64h-448zM576 1024h128v-256h192v256h128v-576h-448z"
				],
				"attrs": [],
				"isMulticolor": false,
				"isMulticolor2": false,
				"tags": [
					"office",
					"buildings",
					"work"
				],
				"defaultCode": 59651,
				"grid": 16
			},
			"attrs": [],
			"properties": {
				"ligatures": "office, buildings",
				"name": "office",
				"order": 101,
				"id": 2,
				"prevSize": 32,
				"code": 59685
			},
			"setIdx": 3,
			"setId": 3,
			"iconIdx": 2
		},
		{
			"icon": {
				"paths": [
					"M864 0h-768c-52.8 0-96 43.2-96 96v832c0 52.8 43.2 96 96 96h768c52.8 0 96-43.2 96-96v-832c0-52.8-43.2-96-96-96zM832 896h-704v-768h704v768zM256 448h448v64h-448zM256 576h448v64h-448zM256 704h448v64h-448zM256 320h448v64h-448z"
				],
				"attrs": [],
				"isMulticolor": false,
				"isMulticolor2": false,
				"tags": [
					"file-text",
					"file",
					"document",
					"list",
					"paper"
				],
				"defaultCode": 59682,
				"grid": 16
			},
			"attrs": [],
			"properties": {
				"ligatures": "file-text, file",
				"name": "file-text",
				"order": 55,
				"id": 3,
				"prevSize": 32,
				"code": 59682
			},
			"setIdx": 3,
			"setId": 3,
			"iconIdx": 3
		},
		{
			"icon": {
				"paths": [
					"M384 928c0 53.019-42.981 96-96 96s-96-42.981-96-96c0-53.019 42.981-96 96-96s96 42.981 96 96z",
					"M1024 928c0 53.019-42.981 96-96 96s-96-42.981-96-96c0-53.019 42.981-96 96-96s96 42.981 96 96z",
					"M1024 512v-384h-768c0-35.346-28.654-64-64-64h-192v64h128l48.074 412.054c-29.294 23.458-48.074 59.5-48.074 99.946 0 70.696 57.308 128 128 128h768v-64h-768c-35.346 0-64-28.654-64-64 0-0.218 0.014-0.436 0.016-0.656l831.984-127.344z"
				],
				"attrs": [],
				"isMulticolor": false,
				"isMulticolor2": false,
				"tags": [
					"cart",
					"purchase",
					"ecommerce",
					"shopping"
				],
				"defaultCode": 59706,
				"grid": 16
			},
			"attrs": [],
			"properties": {
				"ligatures": "cart, purchase",
				"name": "cart",
				"order": 64,
				"id": 4,
				"prevSize": 32,
				"code": 59706
			},
			"setIdx": 3,
			"setId": 3,
			"iconIdx": 4
		},
		{
			"icon": {
				"paths": [
					"M480 64c-265.096 0-480 214.904-480 480 0 265.098 214.904 480 480 480 265.098 0 480-214.902 480-480 0-265.096-214.902-480-480-480zM480 928c-212.078 0-384-171.922-384-384s171.922-384 384-384c212.078 0 384 171.922 384 384s-171.922 384-384 384zM512 512v-128h128v-64h-128v-64h-64v64h-128v256h128v128h-128v64h128v64h64v-64h128.002l-0.002-256h-128zM448 512h-64v-128h64v128zM576.002 704h-64.002v-128h64.002v128z"
				],
				"attrs": [],
				"isMulticolor": false,
				"isMulticolor2": false,
				"tags": [
					"coin-dollar",
					"money",
					"cash",
					"currency-dollar"
				],
				"defaultCode": 59707,
				"grid": 16
			},
			"attrs": [],
			"properties": {
				"ligatures": "coin-dollar, money",
				"name": "coin-dollar",
				"order": 44,
				"id": 5,
				"prevSize": 32,
				"code": 59707
			},
			"setIdx": 3,
			"setId": 3,
			"iconIdx": 5
		},
		{
			"icon": {
				"paths": [
					"M928 128h-832c-52.8 0-96 43.2-96 96v576c0 52.8 43.2 96 96 96h832c52.8 0 96-43.2 96-96v-576c0-52.8-43.2-96-96-96zM96 192h832c17.346 0 32 14.654 32 32v96h-896v-96c0-17.346 14.654-32 32-32zM928 832h-832c-17.346 0-32-14.654-32-32v-288h896v288c0 17.346-14.654 32-32 32zM128 640h64v128h-64zM256 640h64v128h-64zM384 640h64v128h-64z"
				],
				"attrs": [],
				"isMulticolor": false,
				"isMulticolor2": false,
				"tags": [
					"credit-card",
					"money",
					"payment",
					"ecommerce"
				],
				"defaultCode": 59711,
				"grid": 16
			},
			"attrs": [],
			"properties": {
				"ligatures": "credit-card, money5",
				"name": "credit-card1",
				"order": 62,
				"id": 6,
				"prevSize": 32,
				"code": 59711
			},
			"setIdx": 3,
			"setId": 3,
			"iconIdx": 6
		},
		{
			"icon": {
				"paths": [
					"M512 0c-282.77 0-512 229.23-512 512s229.23 512 512 512 512-229.23 512-512-229.23-512-512-512zM320 512c0-106.040 85.96-192 192-192s192 85.96 192 192-85.96 192-192 192-192-85.96-192-192zM925.98 683.476v0l-177.42-73.49c12.518-30.184 19.44-63.276 19.44-97.986s-6.922-67.802-19.44-97.986l177.42-73.49c21.908 52.822 34.020 110.73 34.020 171.476s-12.114 118.654-34.020 171.476v0zM683.478 98.020v0 0l-73.49 177.42c-30.184-12.518-63.276-19.44-97.988-19.44s-67.802 6.922-97.986 19.44l-73.49-177.422c52.822-21.904 110.732-34.018 171.476-34.018 60.746 0 118.654 12.114 171.478 34.020zM98.020 340.524l177.422 73.49c-12.518 30.184-19.442 63.276-19.442 97.986s6.922 67.802 19.44 97.986l-177.42 73.49c-21.906-52.822-34.020-110.73-34.020-171.476s12.114-118.654 34.020-171.476zM340.524 925.98l73.49-177.42c30.184 12.518 63.276 19.44 97.986 19.44s67.802-6.922 97.986-19.44l73.49 177.42c-52.822 21.904-110.73 34.020-171.476 34.020-60.744 0-118.654-12.114-171.476-34.020z"
				],
				"attrs": [],
				"isMulticolor": false,
				"isMulticolor2": false,
				"tags": [
					"lifebuoy",
					"support",
					"help"
				],
				"defaultCode": 59713,
				"grid": 16
			},
			"attrs": [],
			"properties": {
				"ligatures": "lifebuoy, support",
				"name": "lifebuoy",
				"order": 85,
				"id": 7,
				"prevSize": 32,
				"code": 59713
			},
			"setIdx": 3,
			"setId": 3,
			"iconIdx": 7
		},
		{
			"icon": {
				"paths": [
					"M704 640c-64 64-64 128-128 128s-128-64-192-128-128-128-128-192 64-64 128-128-128-256-192-256-192 192-192 192c0 128 131.5 387.5 256 512s384 256 512 256c0 0 192-128 192-192s-192-256-256-192z"
				],
				"attrs": [],
				"isMulticolor": false,
				"isMulticolor2": false,
				"tags": [
					"phone",
					"telephone",
					"contact",
					"support",
					"call"
				],
				"defaultCode": 59714,
				"grid": 16
			},
			"attrs": [],
			"properties": {
				"ligatures": "phone, telephone",
				"name": "phone1",
				"order": 53,
				"id": 8,
				"prevSize": 32,
				"code": 59714
			},
			"setIdx": 3,
			"setId": 3,
			"iconIdx": 8
		},
		{
			"icon": {
				"paths": [
					"M928 128h-832c-52.8 0-96 43.2-96 96v640c0 52.8 43.2 96 96 96h832c52.8 0 96-43.2 96-96v-640c0-52.8-43.2-96-96-96zM398.74 550.372l-270.74 210.892v-501.642l270.74 290.75zM176.38 256h671.24l-335.62 252-335.62-252zM409.288 561.698l102.712 110.302 102.71-110.302 210.554 270.302h-626.528l210.552-270.302zM625.26 550.372l270.74-290.75v501.642l-270.74-210.892z"
				],
				"attrs": [],
				"isMulticolor": false,
				"isMulticolor2": false,
				"tags": [
					"envelop",
					"mail",
					"email",
					"contact",
					"letter"
				],
				"defaultCode": 59717,
				"grid": 16
			},
			"attrs": [],
			"properties": {
				"ligatures": "envelop, mail",
				"name": "envelop",
				"order": 52,
				"id": 9,
				"prevSize": 32,
				"code": 59717
			},
			"setIdx": 3,
			"setId": 3,
			"iconIdx": 9
		},
		{
			"icon": {
				"paths": [
					"M640 64c247.424 0 448 200.576 448 448s-200.576 448-448 448v-96c94.024 0 182.418-36.614 248.902-103.098s103.098-154.878 103.098-248.902c0-94.022-36.614-182.418-103.098-248.902s-154.878-103.098-248.902-103.098c-94.022 0-182.418 36.614-248.902 103.098-51.14 51.138-84.582 115.246-97.306 184.902h186.208l-224 256-224-256h164.57c31.060-217.102 217.738-384 443.43-384zM832 448v128h-256v-320h128v192z"
				],
				"width": 1088,
				"attrs": [],
				"isMulticolor": false,
				"isMulticolor2": false,
				"tags": [
					"history",
					"time",
					"archive",
					"past"
				],
				"defaultCode": 59725,
				"grid": 16
			},
			"attrs": [],
			"properties": {
				"ligatures": "history, time",
				"name": "history",
				"order": 100,
				"id": 10,
				"prevSize": 32,
				"code": 59725
			},
			"setIdx": 3,
			"setId": 3,
			"iconIdx": 10
		},
		{
			"icon": {
				"paths": [
					"M512.002 193.212v-65.212h128v-64c0-35.346-28.654-64-64.002-64h-191.998c-35.346 0-64 28.654-64 64v64h128v65.212c-214.798 16.338-384 195.802-384 414.788 0 229.75 186.25 416 416 416s416-186.25 416-416c0-218.984-169.202-398.448-384-414.788zM706.276 834.274c-60.442 60.44-140.798 93.726-226.274 93.726s-165.834-33.286-226.274-93.726c-60.44-60.44-93.726-140.8-93.726-226.274s33.286-165.834 93.726-226.274c58.040-58.038 134.448-91.018 216.114-93.548l-21.678 314.020c-1.86 26.29 12.464 37.802 31.836 37.802s33.698-11.512 31.836-37.802l-21.676-314.022c81.666 2.532 158.076 35.512 216.116 93.55 60.44 60.44 93.726 140.8 93.726 226.274s-33.286 165.834-93.726 226.274z"
				],
				"attrs": [],
				"isMulticolor": false,
				"isMulticolor2": false,
				"tags": [
					"stopwatch",
					"time",
					"speed",
					"meter",
					"chronometer"
				],
				"defaultCode": 59730,
				"grid": 16
			},
			"attrs": [],
			"properties": {
				"ligatures": "stopwatch, time5",
				"name": "stopwatch",
				"order": 117,
				"id": 11,
				"prevSize": 32,
				"code": 59730
			},
			"setIdx": 3,
			"setId": 3,
			"iconIdx": 11
		},
		{
			"icon": {
				"paths": [
					"M736 0h-448c-52.8 0-96 43.2-96 96v832c0 52.8 43.2 96 96 96h448c52.8 0 96-43.2 96-96v-832c0-52.8-43.2-96-96-96zM384 48h256v32h-256v-32zM512 960c-35.346 0-64-28.654-64-64s28.654-64 64-64 64 28.654 64 64-28.654 64-64 64zM768 768h-512v-640h512v640z"
				],
				"attrs": [],
				"isMulticolor": false,
				"isMulticolor2": false,
				"tags": [
					"mobile",
					"cell-phone",
					"handheld"
				],
				"defaultCode": 59736,
				"grid": 16
			},
			"attrs": [],
			"properties": {
				"ligatures": "mobile, cell-phone",
				"name": "mobile",
				"order": 63,
				"id": 12,
				"prevSize": 32,
				"code": 59736
			},
			"setIdx": 3,
			"setId": 3,
			"iconIdx": 12
		},
		{
			"icon": {
				"paths": [
					"M384 736c0-151.234 95.874-280.486 230.032-330.2 16.28-36.538 25.968-77.164 25.968-117.8 0-159.058 0-288-192-288s-192 128.942-192 288c0 99.060 57.502 198.104 128 237.832v52.78c-217.102 17.748-384 124.42-384 253.388h397.306c-8.664-30.53-13.306-62.732-13.306-96z",
					"M736 448c-159.058 0-288 128.942-288 288s128.942 288 288 288c159.056 0 288-128.942 288-288s-128.942-288-288-288zM896 768h-128v128h-64v-128h-128v-64h128v-128h64v128h128v64z"
				],
				"width": 1024,
				"attrs": [],
				"isMulticolor": false,
				"isMulticolor2": false,
				"tags": [
					"user-plus",
					"user",
					"user-add",
					"profile",
					"avatar",
					"person",
					"member"
				],
				"defaultCode": 59763,
				"grid": 16
			},
			"attrs": [],
			"properties": {
				"ligatures": "user-plus, user2",
				"name": "user-plus",
				"order": 96,
				"id": 13,
				"prevSize": 32,
				"code": 59763
			},
			"setIdx": 3,
			"setId": 3,
			"iconIdx": 13
		},
		{
			"icon": {
				"paths": [
					"M320 192c0-106.039 85.961-192 192-192s192 85.961 192 192c0 106.039-85.961 192-192 192s-192-85.961-192-192zM768.078 448h-35.424l-199.104 404.244 74.45-372.244-96-96-96 96 74.45 372.244-199.102-404.244h-35.424c-127.924 0-127.924 85.986-127.924 192v320h768v-320c0-106.014 0-192-127.922-192z"
				],
				"attrs": [],
				"isMulticolor": false,
				"isMulticolor2": false,
				"tags": [
					"user-tie",
					"user",
					"user-employee",
					"profile",
					"avatar",
					"person",
					"member",
					"job",
					"official"
				],
				"defaultCode": 59766,
				"grid": 16
			},
			"attrs": [],
			"properties": {
				"ligatures": "user-tie, user5",
				"name": "user-tie",
				"order": 35,
				"id": 14,
				"prevSize": 32,
				"code": 59766
			},
			"setIdx": 3,
			"setId": 3,
			"iconIdx": 14
		},
		{
			"icon": {
				"paths": [
					"M1024 384h-384l143.53-143.53c-72.53-72.526-168.96-112.47-271.53-112.47s-199 39.944-271.53 112.47c-72.526 72.53-112.47 168.96-112.47 271.53s39.944 199 112.47 271.53c72.53 72.526 168.96 112.47 271.53 112.47s199-39.944 271.528-112.472c6.056-6.054 11.86-12.292 17.456-18.668l96.32 84.282c-93.846 107.166-231.664 174.858-385.304 174.858-282.77 0-512-229.23-512-512s229.23-512 512-512c141.386 0 269.368 57.326 362.016 149.984l149.984-149.984v384z"
				],
				"attrs": [],
				"isMulticolor": false,
				"isMulticolor2": false,
				"tags": [
					"spinner",
					"loading",
					"loading-wheel",
					"refresh",
					"repeat",
					"busy",
					"wait",
					"arrow"
				],
				"defaultCode": 59780,
				"grid": 16
			},
			"attrs": [],
			"properties": {
				"ligatures": "spinner11, loading12",
				"name": "spinner11",
				"order": 43,
				"id": 15,
				"prevSize": 32,
				"code": 59780
			},
			"setIdx": 3,
			"setId": 3,
			"iconIdx": 15
		},
		{
			"icon": {
				"paths": [
					"M992.262 871.396l-242.552-206.294c-25.074-22.566-51.89-32.926-73.552-31.926 57.256-67.068 91.842-154.078 91.842-249.176 0-212.078-171.922-384-384-384-212.076 0-384 171.922-384 384s171.922 384 384 384c95.098 0 182.108-34.586 249.176-91.844-1 21.662 9.36 48.478 31.926 73.552l206.294 242.552c35.322 39.246 93.022 42.554 128.22 7.356s31.892-92.898-7.354-128.22zM384 640c-141.384 0-256-114.616-256-256s114.616-256 256-256 256 114.616 256 256-114.614 256-256 256z"
				],
				"attrs": [],
				"isMulticolor": false,
				"isMulticolor2": false,
				"tags": [
					"search",
					"magnifier",
					"magnifying-glass",
					"inspect",
					"find"
				],
				"defaultCode": 59782,
				"grid": 16
			},
			"attrs": [],
			"properties": {
				"ligatures": "search, magnifier",
				"name": "search",
				"order": 60,
				"id": 16,
				"prevSize": 32,
				"code": 59782
			},
			"setIdx": 3,
			"setId": 3,
			"iconIdx": 16
		},
		{
			"icon": {
				"paths": [
					"M1002.132 314.242l-101.106-101.104c-24.792-24.794-65.37-65.368-90.162-90.164l-101.106-101.104c-24.792-24.794-68.954-29.166-98.13-9.716l-276.438 184.292c-29.176 19.452-40.218 61.028-24.536 92.39l70.486 140.974c2.154 4.306 4.646 8.896 7.39 13.66l-356.53 356.53-32 224h192v-64h128v-128h128v-128h128v-71.186c6.396 3.812 12.534 7.216 18.192 10.044l140.97 70.488c31.366 15.682 72.94 4.638 92.39-24.538l184.294-276.44c19.454-29.172 15.078-73.33-9.714-98.126zM150.628 854.626l-45.254-45.254 311.572-311.57 45.254 45.254-311.572 311.57zM917.020 423.764l-45.256 45.256c-12.446 12.444-32.808 12.444-45.254 0l-271.53-271.53c-12.446-12.444-12.446-32.81 0-45.254l45.256-45.256c12.446-12.444 32.808-12.444 45.254 0l271.53 271.53c12.446 12.444 12.446 32.81 0 45.254z"
				],
				"attrs": [],
				"isMulticolor": false,
				"isMulticolor2": false,
				"tags": [
					"key",
					"password",
					"login",
					"signin"
				],
				"defaultCode": 59790,
				"grid": 16
			},
			"attrs": [],
			"properties": {
				"ligatures": "key2, password2",
				"name": "key2",
				"order": 102,
				"id": 17,
				"prevSize": 32,
				"code": 59790
			},
			"setIdx": 3,
			"setId": 3,
			"iconIdx": 17
		},
		{
			"icon": {
				"paths": [
					"M448 576v-448c-247.424 0-448 200.576-448 448s200.576 448 448 448 448-200.576 448-448c0-72.034-17.028-140.084-47.236-200.382l-400.764 200.382zM912.764 247.618c-73.552-146.816-225.374-247.618-400.764-247.618v448l400.764-200.382z"
				],
				"attrs": [],
				"isMulticolor": false,
				"isMulticolor2": false,
				"tags": [
					"pie-chart",
					"stats",
					"statistics",
					"graph"
				],
				"defaultCode": 59802,
				"grid": 16
			},
			"attrs": [],
			"properties": {
				"ligatures": "pie-chart, stats",
				"name": "pie-chart",
				"order": 39,
				"id": 18,
				"prevSize": 32,
				"code": 59802
			},
			"setIdx": 3,
			"setId": 3,
			"iconIdx": 18
		},
		{
			"icon": {
				"paths": [
					"M128 896h896v128h-1024v-1024h128zM288 832c-53.020 0-96-42.98-96-96s42.98-96 96-96c2.828 0 5.622 0.148 8.388 0.386l103.192-171.986c-9.84-15.070-15.58-33.062-15.58-52.402 0-53.020 42.98-96 96-96s96 42.98 96 96c0 19.342-5.74 37.332-15.58 52.402l103.192 171.986c2.766-0.238 5.56-0.386 8.388-0.386 2.136 0 4.248 0.094 6.35 0.23l170.356-298.122c-10.536-15.408-16.706-34.036-16.706-54.11 0-53.020 42.98-96 96-96s96 42.98 96 96c0 53.020-42.98 96-96 96-2.14 0-4.248-0.094-6.35-0.232l-170.356 298.124c10.536 15.406 16.706 34.036 16.706 54.11 0 53.020-42.98 96-96 96s-96-42.98-96-96c0-19.34 5.74-37.332 15.578-52.402l-103.19-171.984c-2.766 0.238-5.56 0.386-8.388 0.386s-5.622-0.146-8.388-0.386l-103.192 171.986c9.84 15.068 15.58 33.060 15.58 52.4 0 53.020-42.98 96-96 96z"
				],
				"attrs": [],
				"isMulticolor": false,
				"isMulticolor2": false,
				"tags": [
					"stats-dots",
					"stats",
					"plot",
					"statistics",
					"chart"
				],
				"defaultCode": 59803,
				"grid": 16
			},
			"attrs": [],
			"properties": {
				"ligatures": "stats-dots, stats2",
				"name": "stats-dots",
				"order": 56,
				"id": 19,
				"prevSize": 32,
				"code": 59803
			},
			"setIdx": 3,
			"setId": 3,
			"iconIdx": 19
		},
		{
			"icon": {
				"paths": [
					"M892.268 386.49c2.444-11.11 3.732-22.648 3.732-34.49 0-88.366-71.634-160-160-160-14.222 0-28.014 1.868-41.132 5.352-24.798-77.352-97.29-133.352-182.868-133.352-87.348 0-161.054 58.336-184.326 138.17-22.742-6.622-46.792-10.17-71.674-10.17-141.384 0-256 114.616-256 256 0 141.388 114.616 256 256 256h128v192h256v-192h224c88.366 0 160-71.632 160-160 0-78.72-56.854-144.162-131.732-157.51zM576 640v192h-128v-192h-160l224-224 224 224h-160z"
				],
				"attrs": [],
				"isMulticolor": false,
				"isMulticolor2": false,
				"tags": [
					"cloud-upload",
					"cloud",
					"load",
					"upload"
				],
				"defaultCode": 59843,
				"grid": 16
			},
			"attrs": [],
			"properties": {
				"ligatures": "cloud-upload, cloud3",
				"name": "cloud-upload",
				"order": 82,
				"id": 20,
				"prevSize": 32,
				"code": 59843
			},
			"setIdx": 3,
			"setId": 3,
			"iconIdx": 20
		},
		{
			"icon": {
				"paths": [
					"M512 0c-282.77 0-512 229.23-512 512s229.23 512 512 512 512-229.23 512-512-229.23-512-512-512zM512 960.002c-62.958 0-122.872-13.012-177.23-36.452l233.148-262.29c5.206-5.858 8.082-13.422 8.082-21.26v-96c0-17.674-14.326-32-32-32-112.99 0-232.204-117.462-233.374-118.626-6-6.002-14.14-9.374-22.626-9.374h-128c-17.672 0-32 14.328-32 32v192c0 12.122 6.848 23.202 17.69 28.622l110.31 55.156v187.886c-116.052-80.956-192-215.432-192-367.664 0-68.714 15.49-133.806 43.138-192h116.862c8.488 0 16.626-3.372 22.628-9.372l128-128c6-6.002 9.372-14.14 9.372-22.628v-77.412c40.562-12.074 83.518-18.588 128-18.588 70.406 0 137.004 16.26 196.282 45.2-4.144 3.502-8.176 7.164-12.046 11.036-36.266 36.264-56.236 84.478-56.236 135.764s19.97 99.5 56.236 135.764c36.434 36.432 85.218 56.264 135.634 56.26 3.166 0 6.342-0.080 9.518-0.236 13.814 51.802 38.752 186.656-8.404 372.334-0.444 1.744-0.696 3.488-0.842 5.224-81.324 83.080-194.7 134.656-320.142 134.656z"
				],
				"attrs": [],
				"isMulticolor": false,
				"isMulticolor2": false,
				"tags": [
					"earth",
					"globe",
					"language",
					"web",
					"internet",
					"sphere",
					"planet"
				],
				"defaultCode": 59850,
				"grid": 16
			},
			"attrs": [],
			"properties": {
				"ligatures": "earth, globe2",
				"name": "earth",
				"order": 98,
				"id": 21,
				"prevSize": 32,
				"code": 59850
			},
			"setIdx": 3,
			"setId": 3,
			"iconIdx": 21
		},
		{
			"icon": {
				"paths": [
					"M512 192c-223.318 0-416.882 130.042-512 320 95.118 189.958 288.682 320 512 320 223.312 0 416.876-130.042 512-320-95.116-189.958-288.688-320-512-320zM764.45 361.704c60.162 38.374 111.142 89.774 149.434 150.296-38.292 60.522-89.274 111.922-149.436 150.296-75.594 48.218-162.89 73.704-252.448 73.704-89.56 0-176.858-25.486-252.452-73.704-60.158-38.372-111.138-89.772-149.432-150.296 38.292-60.524 89.274-111.924 149.434-150.296 3.918-2.5 7.876-4.922 11.86-7.3-9.96 27.328-15.41 56.822-15.41 87.596 0 141.382 114.616 256 256 256 141.382 0 256-114.618 256-256 0-30.774-5.452-60.268-15.408-87.598 3.978 2.378 7.938 4.802 11.858 7.302v0zM512 416c0 53.020-42.98 96-96 96s-96-42.98-96-96 42.98-96 96-96 96 42.982 96 96z"
				],
				"attrs": [],
				"isMulticolor": false,
				"isMulticolor2": false,
				"tags": [
					"eye",
					"views",
					"vision",
					"visit"
				],
				"defaultCode": 59854,
				"grid": 16
			},
			"attrs": [],
			"properties": {
				"ligatures": "eye, views",
				"name": "eye",
				"order": 112,
				"id": 22,
				"prevSize": 32,
				"code": 59854
			},
			"setIdx": 3,
			"setId": 3,
			"iconIdx": 22
		},
		{
			"icon": {
				"paths": [
					"M512 92.774l429.102 855.226h-858.206l429.104-855.226zM512 0c-22.070 0-44.14 14.882-60.884 44.648l-437.074 871.112c-33.486 59.532-5 108.24 63.304 108.24h869.308c68.3 0 96.792-48.708 63.3-108.24h0.002l-437.074-871.112c-16.742-29.766-38.812-44.648-60.882-44.648v0z",
					"M576 832c0 35.346-28.654 64-64 64s-64-28.654-64-64c0-35.346 28.654-64 64-64s64 28.654 64 64z",
					"M512 704c-35.346 0-64-28.654-64-64v-192c0-35.346 28.654-64 64-64s64 28.654 64 64v192c0 35.346-28.654 64-64 64z"
				],
				"attrs": [],
				"isMulticolor": false,
				"isMulticolor2": false,
				"tags": [
					"warning",
					"sign"
				],
				"defaultCode": 59911,
				"grid": 16
			},
			"attrs": [],
			"properties": {
				"ligatures": "warning, sign",
				"name": "warning",
				"order": 109,
				"id": 23,
				"prevSize": 32,
				"code": 59911
			},
			"setIdx": 3,
			"setId": 3,
			"iconIdx": 23
		},
		{
			"icon": {
				"paths": [
					"M1014.662 822.66c-0.004-0.004-0.008-0.008-0.012-0.010l-310.644-310.65 310.644-310.65c0.004-0.004 0.008-0.006 0.012-0.010 3.344-3.346 5.762-7.254 7.312-11.416 4.246-11.376 1.824-24.682-7.324-33.83l-146.746-146.746c-9.148-9.146-22.45-11.566-33.828-7.32-4.16 1.55-8.070 3.968-11.418 7.31 0 0.004-0.004 0.006-0.008 0.010l-310.648 310.652-310.648-310.65c-0.004-0.004-0.006-0.006-0.010-0.010-3.346-3.342-7.254-5.76-11.414-7.31-11.38-4.248-24.682-1.826-33.83 7.32l-146.748 146.748c-9.148 9.148-11.568 22.452-7.322 33.828 1.552 4.16 3.97 8.072 7.312 11.416 0.004 0.002 0.006 0.006 0.010 0.010l310.65 310.648-310.65 310.652c-0.002 0.004-0.006 0.006-0.008 0.010-3.342 3.346-5.76 7.254-7.314 11.414-4.248 11.376-1.826 24.682 7.322 33.83l146.748 146.746c9.15 9.148 22.452 11.568 33.83 7.322 4.16-1.552 8.070-3.97 11.416-7.312 0.002-0.004 0.006-0.006 0.010-0.010l310.648-310.65 310.648 310.65c0.004 0.002 0.008 0.006 0.012 0.008 3.348 3.344 7.254 5.762 11.414 7.314 11.378 4.246 24.684 1.826 33.828-7.322l146.746-146.748c9.148-9.148 11.57-22.454 7.324-33.83-1.552-4.16-3.97-8.068-7.314-11.414z"
				],
				"attrs": [],
				"isMulticolor": false,
				"isMulticolor2": false,
				"tags": [
					"cross",
					"cancel",
					"close",
					"quit",
					"remove"
				],
				"defaultCode": 59919,
				"grid": 16
			},
			"attrs": [],
			"properties": {
				"ligatures": "cross, cancel",
				"name": "cross",
				"order": 115,
				"id": 24,
				"prevSize": 32,
				"code": 59919
			},
			"setIdx": 3,
			"setId": 3,
			"iconIdx": 24
		},
		{
			"icon": {
				"paths": [
					"M864 128l-480 480-224-224-160 160 384 384 640-640z"
				],
				"attrs": [],
				"isMulticolor": false,
				"isMulticolor2": false,
				"tags": [
					"checkmark",
					"tick",
					"correct",
					"accept",
					"ok"
				],
				"defaultCode": 59920,
				"grid": 16
			},
			"attrs": [],
			"properties": {
				"ligatures": "checkmark, tick",
				"name": "checkmark1",
				"order": 116,
				"id": 25,
				"prevSize": 32,
				"code": 59920
			},
			"setIdx": 3,
			"setId": 3,
			"iconIdx": 25
		},
		{
			"icon": {
				"paths": [
					"M425.6 37.4c-1.6-1-3.4-1.8-5-2.6-1.8 0.4-3.4 0.6-5.2 1l10.2 1.6z",
					"M36.8 421c-0.4 1.8-0.6 3.6-0.8 5.2 1 1.6 1.6 3.2 2.6 4.8l-1.8-10z",
					"M986.8 602.6c0.4-1.8 0.6-3.6 1-5.4-1-1.6-1.6-3.2-2.6-4.8l1.6 10.2z",
					"M592 983c1.6 1 3.4 1.8 5 2.6 1.8-0.4 3.6-0.6 5.4-0.8l-10.4-1.8z",
					"M987.8 597.2c-0.4 1.8-0.6 3.6-1 5.4l-1.8-10.4c1 1.8 1.8 3.4 2.8 5 5.2-28.8 8-58.2 8-87.6 0-65.2-12.8-128.6-38-188.2-24.4-57.6-59.2-109.4-103.6-153.8s-96.2-79.2-153.6-103.6c-59.6-25.2-123-38-188.2-38-30.8 0-61.6 2.8-91.6 8.6 0 0-0.2 0-0.2 0 1.6 0.8 3.4 1.6 5 2.6l-10.2-1.6c1.8-0.4 3.4-0.6 5.2-1-41.2-21.8-87.4-33.6-134.2-33.6-76.4 0-148.4 29.8-202.4 83.8s-83.8 126-83.8 202.4c0 48.6 12.6 96.6 36 138.8 0.4-1.8 0.6-3.6 0.8-5.2l1.8 10.2c-1-1.6-1.8-3.2-2.6-4.8-4.8 27.4-7.2 55.4-7.2 83.4 0 65.2 12.8 128.6 38 188.2 24.4 57.6 59.2 109.2 103.6 153.6s96.2 79.2 153.8 103.6c59.6 25.2 123 38 188.2 38 28.4 0 56.8-2.6 84.6-7.6-1.6-1-3.2-1.8-5-2.6l10.4 1.8c-1.8 0.4-3.6 0.6-5.4 0.8 42.8 24.2 91.4 37.2 140.8 37.2 76.4 0 148.4-29.8 202.4-83.8s83.8-126 83.8-202.4c-0.2-48.6-12.8-96.6-36.4-139.2zM514.2 805.8c-171.8 0-248.6-84.4-248.6-147.8 0-32.4 24-55.2 57-55.2 73.6 0 54.4 105.6 191.6 105.6 70.2 0 109-38.2 109-77.2 0-23.4-11.6-49.4-57.8-60.8l-152.8-38.2c-123-30.8-145.4-97.4-145.4-160 0-129.8 122.2-178.6 237-178.6 105.8 0 230.4 58.4 230.4 136.4 0 33.4-29 52.8-62 52.8-62.8 0-51.2-86.8-177.6-86.8-62.8 0-97.4 28.4-97.4 69s49.6 53.6 92.6 63.4l113.2 25.2c123.8 27.6 155.2 100 155.2 168 0 105.4-81 184.2-244.4 184.2z"
				],
				"attrs": [],
				"isMulticolor": false,
				"isMulticolor2": false,
				"tags": [
					"skype",
					"brand",
					"social"
				],
				"defaultCode": 60101,
				"grid": 16
			},
			"attrs": [],
			"properties": {
				"ligatures": "skype, brand60",
				"name": "skype",
				"order": 86,
				"id": 26,
				"prevSize": 32,
				"code": 60101
			},
			"setIdx": 3,
			"setId": 3,
			"iconIdx": 26
		},
		{
			"icon": {
				"paths": [
					"M743.028 384h-135.292l-95.732 141.032-95.742-141.032h-135.29l162.162 242.464-182.972 269.536h251.838v-91.576h-50.156l50.156-74.994 111.396 166.57h140.444l-182.976-269.536 162.164-242.464z",
					"M917.806 229.076c-22.21-30.292-53.174-65.7-87.178-99.704s-69.412-64.964-99.704-87.178c-51.574-37.82-76.592-42.194-90.924-42.194h-496c-44.112 0-80 35.888-80 80v864c0 44.112 35.886 80 80 80h736c44.112 0 80-35.888 80-80v-624c0-14.332-4.372-39.35-42.194-90.924v0zM785.374 174.626c30.7 30.7 54.8 58.398 72.58 81.374h-153.954v-153.946c22.982 17.78 50.678 41.878 81.374 72.572v0zM896 944c0 8.672-7.328 16-16 16h-736c-8.672 0-16-7.328-16-16v-864c0-8.672 7.328-16 16-16 0 0 495.956-0.002 496 0v224c0 17.672 14.324 32 32 32h224v624z"
				],
				"attrs": [],
				"isMulticolor": false,
				"isMulticolor2": false,
				"tags": [
					"file-excel",
					"file",
					"file-format",
					"xlc"
				],
				"defaultCode": 60130,
				"grid": 16
			},
			"attrs": [],
			"properties": {
				"ligatures": "file-excel, file13",
				"name": "file-excel",
				"order": 68,
				"id": 27,
				"prevSize": 32,
				"code": 60130
			},
			"setIdx": 3,
			"setId": 3,
			"iconIdx": 27
		},
		{
			"icon": {
				"paths": [
					"M992 384h-352v-352c0-17.672-14.328-32-32-32h-192c-17.672 0-32 14.328-32 32v352h-352c-17.672 0-32 14.328-32 32v192c0 17.672 14.328 32 32 32h352v352c0 17.672 14.328 32 32 32h192c17.672 0 32-14.328 32-32v-352h352c17.672 0 32-14.328 32-32v-192c0-17.672-14.328-32-32-32z"
				],
				"attrs": [],
				"isMulticolor": false,
				"isMulticolor2": false,
				"tags": [
					"plus",
					"add",
					"sum"
				],
				"defaultCode": 59914,
				"grid": 16
			},
			"attrs": [],
			"properties": {
				"ligatures": "plus, add",
				"name": "plus",
				"order": 2,
				"id": 28,
				"prevSize": 32,
				"code": 59914
			},
			"setIdx": 3,
			"setId": 3,
			"iconIdx": 28
		},
		{
			"icon": {
				"paths": [
					"M928 128h-832c-52.8 0-96 43.2-96 96v576c0 52.8 43.2 96 96 96h832c52.8 0 96-43.2 96-96v-576c0-52.8-43.2-96-96-96zM96 192h832c17.346 0 32 14.654 32 32v96h-896v-96c0-17.346 14.654-32 32-32zM928 832h-832c-17.346 0-32-14.654-32-32v-288h896v288c0 17.346-14.654 32-32 32zM128 640h64v128h-64zM256 640h64v128h-64zM384 640h64v128h-64z"
				],
				"tags": [
					"credit-card",
					"money",
					"payment",
					"ecommerce"
				],
				"defaultCode": 59711,
				"grid": 16,
				"attrs": []
			},
			"attrs": [],
			"properties": {
				"ligatures": "credit-card, money5",
				"name": "credit-card",
				"order": 3,
				"id": 64,
				"prevSize": 32,
				"code": 59712
			},
			"setIdx": 5,
			"setId": 1,
			"iconIdx": 63
		},
		{
			"icon": {
				"paths": [
					"M219.429 877.714h438.857v-219.429h-438.857v219.429zM731.429 877.714h73.143v-512c0-10.857-9.714-34.286-17.143-41.714l-160.571-160.571c-8-8-30.286-17.143-41.714-17.143v237.714c0 30.286-24.571 54.857-54.857 54.857h-329.143c-30.286 0-54.857-24.571-54.857-54.857v-237.714h-73.143v731.429h73.143v-237.714c0-30.286 24.571-54.857 54.857-54.857h475.429c30.286 0 54.857 24.571 54.857 54.857v237.714zM512 347.429v-182.857c0-9.714-8.571-18.286-18.286-18.286h-109.714c-9.714 0-18.286 8.571-18.286 18.286v182.857c0 9.714 8.571 18.286 18.286 18.286h109.714c9.714 0 18.286-8.571 18.286-18.286zM877.714 365.714v530.286c0 30.286-24.571 54.857-54.857 54.857h-768c-30.286 0-54.857-24.571-54.857-54.857v-768c0-30.286 24.571-54.857 54.857-54.857h530.286c30.286 0 72 17.143 93.714 38.857l160 160c21.714 21.714 38.857 63.429 38.857 93.714z"
				],
				"width": 878,
				"attrs": [
					{}
				],
				"isMulticolor": false,
				"isMulticolor2": false,
				"tags": [
					"floppy-o",
					"save"
				],
				"grid": 14
			},
			"attrs": [
				{}
			],
			"properties": {
				"order": 114,
				"id": 0,
				"prevSize": 28,
				"code": 59692,
				"name": "floppy-o"
			},
			"setIdx": 4,
			"setId": 2,
			"iconIdx": 0
		},
		{
			"icon": {
				"paths": [
					"M521.143 969.143c0-5.143-4-9.143-9.143-9.143-45.143 0-82.286-37.143-82.286-82.286 0-5.143-4-9.143-9.143-9.143s-9.143 4-9.143 9.143c0 55.429 45.143 100.571 100.571 100.571 5.143 0 9.143-4 9.143-9.143zM140.571 804.571h742.857c-102.286-115.429-152-272-152-475.429 0-73.714-69.714-182.857-219.429-182.857s-219.429 109.143-219.429 182.857c0 203.429-49.714 360-152 475.429zM987.429 804.571c0 40-33.143 73.143-73.143 73.143h-256c0 80.571-65.714 146.286-146.286 146.286s-146.286-65.714-146.286-146.286h-256c-40 0-73.143-33.143-73.143-73.143 84.571-71.429 182.857-199.429 182.857-475.429 0-109.714 90.857-229.714 242.286-252-2.857-6.857-4.571-14.286-4.571-22.286 0-30.286 24.571-54.857 54.857-54.857s54.857 24.571 54.857 54.857c0 8-1.714 15.429-4.571 22.286 151.429 22.286 242.286 142.286 242.286 252 0 276 98.286 404 182.857 475.429z"
				],
				"attrs": [
					{}
				],
				"isMulticolor": false,
				"isMulticolor2": false,
				"tags": [
					"bell-o"
				],
				"grid": 14
			},
			"attrs": [
				{}
			],
			"properties": {
				"order": 1,
				"id": 1,
				"prevSize": 28,
				"code": 59676,
				"name": "bell-o"
			},
			"setIdx": 4,
			"setId": 2,
			"iconIdx": 1
		},
		{
			"icon": {
				"paths": [
					"M679.429 746.857l84-396c7.429-34.857-12.571-48.571-35.429-40l-493.714 190.286c-33.714 13.143-33.143 32-5.714 40.571l126.286 39.429 293.143-184.571c13.714-9.143 26.286-4 16 5.143l-237.143 214.286-9.143 130.286c13.143 0 18.857-5.714 25.714-12.571l61.714-59.429 128 94.286c23.429 13.143 40 6.286 46.286-21.714zM1024 512c0 282.857-229.143 512-512 512s-512-229.143-512-512 229.143-512 512-512 512 229.143 512 512z"
				],
				"attrs": [
					{}
				],
				"isMulticolor": false,
				"isMulticolor2": false,
				"tags": [
					"telegram"
				],
				"grid": 14
			},
			"attrs": [
				{}
			],
			"properties": {
				"order": 1,
				"id": 2,
				"prevSize": 28,
				"code": 59673,
				"name": "telegram"
			},
			"setIdx": 4,
			"setId": 2,
			"iconIdx": 2
		},
		{
			"icon": {
				"paths": [
					"M178.857 444c0 18.286-7.429 36-20.571 48-11.429 10.286-26.857 14.857-50.857 14.857h-9.714v-125.714h9.714c24 0 38.857 4 50.857 15.429 13.143 11.429 20.571 29.143 20.571 47.429zM1193.714 406.857c0 19.429-12.571 29.714-36.571 29.714h-10.857v-57.714h11.429c23.429 0 36 9.714 36 28zM217.143 444c0-56-41.714-95.429-102.286-95.429h-54.286v190.286h54.286c28.571 0 49.714-6.286 68-21.714 21.714-18.286 34.286-45.143 34.286-73.143zM234.286 538.857h37.143v-190.286h-37.143v190.286zM417.143 481.143c0-30.286-12.571-44-54.857-59.429-22.286-8-28.571-13.714-28.571-24 0-12 11.429-21.143 27.429-21.143 11.429 0 20.571 4.571 30.286 15.429l19.429-25.143c-16-14.286-35.429-21.143-56-21.143-33.714 0-59.429 23.429-59.429 54.286 0 26.286 12 40 46.857 52.571 14.286 5.143 21.714 8 25.714 10.857 7.429 4.571 10.857 11.429 10.857 19.429 0 15.429-12 26.857-28.571 26.857-17.714 0-32-8.571-40.571-25.143l-24 22.857c17.143 25.143 37.714 36.571 65.714 36.571 38.857 0 65.714-25.714 65.714-62.857zM576 532.571v-44c-14.857 14.857-28 21.143-44.571 21.143-37.714 0-64-27.429-64-65.714 0-36.571 27.429-65.714 62.286-65.714 17.714 0 30.857 6.286 46.286 21.714v-44c-16-8-29.714-11.429-45.714-11.429-56 0-101.143 44-101.143 99.429 0 56 44 99.429 100.571 99.429 16 0 29.714-2.857 46.286-10.857zM1280 877.714v-301.143c-91.429 57.143-413.143 240-933.143 337.714h896.571c20 0 36.571-16.571 36.571-36.571zM793.714 445.143c0-57.143-46.286-103.429-103.429-103.429s-103.429 46.286-103.429 103.429 46.286 103.429 103.429 103.429 103.429-46.286 103.429-103.429zM880.571 544l82.286-195.429h-40.571l-51.429 128-50.857-128h-40.571l81.143 195.429h20zM979.429 538.857h105.143v-32h-68v-51.429h65.714v-32h-65.714v-42.286h68v-32.571h-105.143v190.286zM1202.857 538.857h45.714l-60-80c28-5.714 43.429-24.571 43.429-53.714 0-36-24.571-56.571-67.429-56.571h-55.429v190.286h37.143v-76h5.143zM1316.571 149.714v724.571c0 42.286-33.714 76.571-75.429 76.571h-1165.714c-41.714 0-75.429-34.286-75.429-76.571v-724.571c0-42.286 33.714-76.571 75.429-76.571h1165.714c41.714 0 75.429 34.286 75.429 76.571z"
				],
				"width": 1317,
				"attrs": [
					{}
				],
				"isMulticolor": false,
				"isMulticolor2": false,
				"tags": [
					"cc-discover"
				],
				"grid": 14
			},
			"attrs": [
				{}
			],
			"properties": {
				"order": 1,
				"id": 3,
				"prevSize": 28,
				"code": 59669,
				"name": "cc-discover"
			},
			"setIdx": 4,
			"setId": 2,
			"iconIdx": 3
		},
		{
			"icon": {
				"paths": [
					"M490.286 709.143v-396c-79.429 30.857-136 108-136 198.286s56.571 167.429 136 197.714zM778.286 511.429c0-90.286-56.571-167.429-136-198.286v396.571c79.429-30.857 136-108 136-198.286zM901.143 511.429c0 184.571-149.714 334.857-334.857 334.857-184.571 0-334.857-150.286-334.857-334.857 0-185.143 150.286-334.857 334.857-334.857 185.143 0 334.857 149.714 334.857 334.857zM1120 515.429c0-218.286-182.286-369.143-382.286-369.143h-172c-202.286 0-369.143 150.857-369.143 369.143 0 199.429 166.857 362.286 369.143 362.286h172c200 0 382.286-162.857 382.286-362.286zM1316.571 146.286v731.429c0 40-33.143 73.143-73.143 73.143h-1170.286c-40 0-73.143-33.143-73.143-73.143v-731.429c0-40 33.143-73.143 73.143-73.143h1170.286c40 0 73.143 33.143 73.143 73.143z"
				],
				"width": 1317,
				"attrs": [
					{}
				],
				"isMulticolor": false,
				"isMulticolor2": false,
				"tags": [
					"cc-diners-club"
				],
				"grid": 14
			},
			"attrs": [
				{}
			],
			"properties": {
				"order": 1,
				"id": 4,
				"prevSize": 28,
				"code": 59666,
				"name": "cc-diners-club"
			},
			"setIdx": 4,
			"setId": 2,
			"iconIdx": 4
		},
		{
			"icon": {
				"paths": [
					"M1114.857 570.286c0 20.571-13.714 35.429-30.857 38.857-2.286 0.571-7.429 1.143-10.286 1.143h-87.429v-80h87.429c2.857 0 8 0.571 10.286 1.143 17.143 3.429 30.857 18.857 30.857 38.857zM1104.571 448.571c0 20-13.714 33.143-30.286 36-1.714 0.571-5.714 0.571-8.571 0.571h-79.429v-73.714h79.429c2.857 0 6.857 0.571 8.571 0.571 16.571 2.857 30.286 16.571 30.286 36.571zM416 542.286v-176h-130.286v176c0 42.857-29.143 74.857-81.714 74.857-44.571 0-88.571-13.143-130.857-33.714v64c68.571 18.857 155.429 18.857 155.429 18.857 145.143 0 187.429-55.429 187.429-124zM824 647.429v-64.571c-29.714 15.429-67.429 30.286-114.286 33.714-82.286 6.286-131.429-33.714-131.429-104.571s49.143-110.857 131.429-104.571c46.857 3.429 84 17.714 114.286 33.143v-64c-61.143-15.429-118.857-17.714-118.857-17.714-201.143-9.143-258.286 70.286-258.286 153.143s57.143 162.286 258.286 153.143c0 0 57.714-2.286 118.857-17.714zM1243.429 581.714c0-42.286-37.714-69.714-86.857-73.143v-1.714c44.571-6.286 69.143-35.429 69.143-69.143 0-43.429-36-68.571-84.571-70.857-3.429 0-9.714-0.571-14.857-0.571h-260v291.429h280.571c55.429 0 96.571-29.714 96.571-76zM1316.571 146.286v731.429c0 40-33.143 73.143-73.143 73.143h-1170.286c-40 0-73.143-33.143-73.143-73.143v-731.429c0-40 33.143-73.143 73.143-73.143h1170.286c40 0 73.143 33.143 73.143 73.143z"
				],
				"width": 1317,
				"attrs": [
					{}
				],
				"isMulticolor": false,
				"isMulticolor2": false,
				"tags": [
					"cc-jcb"
				],
				"grid": 14
			},
			"attrs": [
				{}
			],
			"properties": {
				"order": 1,
				"id": 5,
				"prevSize": 28,
				"code": 59665,
				"name": "cc-jcb"
			},
			"setIdx": 4,
			"setId": 2,
			"iconIdx": 5
		}
	],
	"height": 1024,
	"metadata": {
		"name": "icomoon"
	},
	"preferences": {
		"showGlyphs": true,
		"showQuickUse": true,
		"showQuickUse2": true,
		"showSVGs": true,
		"fontPref": {
			"prefix": "icon-",
			"metadata": {
				"fontFamily": "icomoon"
			},
			"metrics": {
				"emSize": 1024,
				"baseline": 6.25,
				"whitespace": 50
			},
			"embed": false
		},
		"imagePref": {
			"prefix": "icon-",
			"png": true,
			"useClassSelector": true,
			"color": 0,
			"bgColor": 16777215,
			"classSelector": ".icon"
		},
		"historySize": 50,
		"showCodes": true,
		"gridSize": 16
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/Components/Utils/Icon/selection.json
// module id = 663
// module chunks = 0